import { PRIMARY_COLOR } from '../../config/color';

export const ButtonArrow = () => (
  <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 22 22" fill="none">
    <path d="M19.25 11.5H2.75" stroke="currentColor" stroke-width="1.375" />
    <path d="M13.75 6L19.25 11.5L13.75 17" stroke="currentColor" stroke-width="1.375" />
  </svg>
);

export const LinkCardArrow = () => (
  <svg viewBox="0 0 85 85" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path d="M74.3748 42.5H10.6249" stroke="white" stroke-width="4" />
    <path d="M53.125 21.25L74.375 42.5L53.125 63.75" stroke="white" stroke-width="4" />
  </svg>
);

export const Line01 = () => (
  <svg viewBox="0 0 66 388" fill="none" xmlns="http://www.w3.org/2000/svg">
    <line x1="33.5" y1="80" x2="33.5" y2="388" stroke="#CACACA" />
    <path
      d="M33.4213 41.3191C36.8576 41.3191 39.6433 38.5334 39.6433 35.097C39.6433 31.6607 36.8576 28.875 33.4213 28.875C29.9849 28.875 27.1992 31.6607 27.1992 35.097C27.1992 38.5334 29.9849 41.3191 33.4213 41.3191Z"
      fill={PRIMARY_COLOR}
      stroke="white"
      stroke-width="2"
    />
    <path
      d="M64.2853 31.2856C64.6244 37.4733 63.1211 43.6225 59.9654 48.9558C56.8097 54.289 52.1434 58.5668 46.5565 61.248C40.9697 63.9292 34.7132 64.8935 28.5783 64.019C22.4434 63.1445 16.7055 60.4704 12.0904 56.3348C7.47528 52.1993 4.19011 46.7881 2.65034 40.7855C1.11058 34.7829 1.38536 28.4585 3.43996 22.6121C5.49455 16.7657 9.23667 11.6598 14.1931 7.94016C19.1495 4.2205 25.0977 2.05413 31.2853 1.715"
      stroke={PRIMARY_COLOR}
      stroke-width="2"
      stroke-dasharray="4 4"
    />
    <circle cx="33.0977" cy="207" r="6" fill="#CACACA" stroke="white" stroke-width="2" />
    <circle cx="33.0977" cy="381" r="6" fill="#CACACA" stroke="white" stroke-width="2" />
  </svg>
);

export const Line02 = () => (
  <svg viewBox="0 0 66 388" fill="none" xmlns="http://www.w3.org/2000/svg">
    <line x1="33.5" y1="228" x2="33.5" y2="361" stroke="#CACACA" />
    <line x1="33.5" y1="12" x2="33.5" y2="134" stroke="#CACACA" />
    <path
      d="M33.4213 189.319C36.8576 189.319 39.6433 186.533 39.6433 183.097C39.6433 179.661 36.8576 176.875 33.4213 176.875C29.9849 176.875 27.1992 179.661 27.1992 183.097C27.1992 186.533 29.9849 189.319 33.4213 189.319Z"
      fill={PRIMARY_COLOR}
      stroke="white"
      stroke-width="2"
    />
    <path
      d="M64.2853 179.286C64.6244 185.473 63.1211 191.623 59.9654 196.956C56.8097 202.289 52.1434 206.567 46.5565 209.248C40.9697 211.929 34.7132 212.894 28.5783 212.019C22.4434 211.144 16.7055 208.47 12.0904 204.335C7.47528 200.199 4.19011 194.788 2.65034 188.786C1.11058 182.783 1.38536 176.459 3.43996 170.612C5.49455 164.766 9.23667 159.66 14.1931 155.94C19.1495 152.221 25.0977 150.054 31.2853 149.715"
      stroke="#4905B8"
      stroke-width="2"
      stroke-dasharray="4 4"
    />
    <circle cx="33.0977" cy="7" r="6" fill="#CACACA" stroke="white" stroke-width="2" />
    <circle cx="33.0977" cy="358.578" r="6" fill="#CACACA" stroke="white" stroke-width="2" />
  </svg>
);

export const Line03 = () => (
  <svg viewBox="0 0 66 388" fill="none" xmlns="http://www.w3.org/2000/svg">
    <line x1="33.5" y1="7" x2="33.5" y2="308" stroke="#CACACA" />
    <path
      d="M33.4213 363.319C36.8576 363.319 39.6433 360.533 39.6433 357.097C39.6433 353.661 36.8576 350.875 33.4213 350.875C29.9849 350.875 27.1992 353.661 27.1992 357.097C27.1992 360.533 29.9849 363.319 33.4213 363.319Z"
      fill="#D642A6"
      stroke="white"
      stroke-width="2"
    />
    <path
      d="M64.2853 353.286C64.6244 359.473 63.1211 365.623 59.9654 370.956C56.8097 376.289 52.1434 380.567 46.5565 383.248C40.9697 385.929 34.7132 386.894 28.5783 386.019C22.4434 385.144 16.7055 382.47 12.0904 378.335C7.47528 374.199 4.19011 368.788 2.65034 362.786C1.11058 356.783 1.38536 350.459 3.43996 344.612C5.49455 338.766 9.23667 333.66 14.1931 329.94C19.1495 326.221 25.0977 324.054 31.2853 323.715"
      stroke="#D642A6"
      stroke-width="2"
      stroke-dasharray="4 4"
    />
    <circle cx="33.0977" cy="181" r="6" fill="#CACACA" stroke="white" stroke-width="2" />
    <circle cx="33.0977" cy="7" r="6" fill="#CACACA" stroke="white" stroke-width="2" />
  </svg>
);

export const CertificateSVG = () => (
  <svg viewBox="0 0 18 18" fill="none" xmlns="http://www.w3.org/2000/svg">
    <g clip-path="url(#clip0_4174_18404)">
      <path
        d="M9.08061 17.3836C8.70711 17.3836 8.36061 17.1991 8.15361 16.8886L7.05561 15.2371C6.86211 14.9446 6.51111 14.8006 6.16461 14.8681L4.22061 15.2596C3.85611 15.3316 3.47811 15.2191 3.21261 14.9581C2.94711 14.6926 2.83461 14.3191 2.91111 13.9501L3.30261 12.0061C3.37011 11.6596 3.22611 11.3131 2.93361 11.1151L1.28211 10.0171C0.971609 9.81006 0.787109 9.46356 0.787109 9.09006C0.787109 8.71656 0.971609 8.37006 1.28211 8.16306L2.93361 7.06506C3.22611 6.87156 3.37011 6.52056 3.30261 6.17406L2.91111 4.23006C2.83911 3.86556 2.95161 3.48756 3.21261 3.22656C3.47811 2.96106 3.85161 2.84856 4.22061 2.92506L6.16461 3.31656C6.51111 3.38856 6.85761 3.24006 7.05561 2.94756L8.15361 1.30506C8.36061 0.994559 8.70711 0.810059 9.08061 0.810059C9.45411 0.810059 9.80061 0.994559 10.0076 1.30506L11.1056 2.95656C11.2991 3.24906 11.6501 3.39306 11.9966 3.32556L13.9406 2.93406C14.3051 2.86206 14.6831 2.97456 14.9486 3.23556C15.2141 3.49656 15.3266 3.87456 15.2501 4.23906L14.8586 6.18306C14.7911 6.52956 14.9351 6.87606 15.2276 7.07406L16.8791 8.17206C17.1896 8.37906 17.3741 8.72556 17.3741 9.09906C17.3741 9.47256 17.1896 9.81906 16.8791 10.0261L15.2186 11.1151C14.9261 11.3086 14.7821 11.6596 14.8496 12.0061L15.2411 13.9456C15.3131 14.3101 15.2006 14.6881 14.9396 14.9536C14.6741 15.2191 14.3006 15.3316 13.9316 15.2551L11.9876 14.8636C11.6411 14.7961 11.2946 14.9401 11.0966 15.2326L9.99861 16.8841C9.80061 17.1946 9.45411 17.3836 9.08061 17.3836ZM6.34461 13.7701C6.98811 13.7701 7.59561 14.0896 7.96011 14.6386L9.05811 16.2901C9.06261 16.2946 9.06711 16.3036 9.08511 16.3036C9.10311 16.3036 9.10761 16.2946 9.11211 16.2901L10.2101 14.6386C10.6511 13.9771 11.4341 13.6531 12.2126 13.8106L14.1566 14.2021C14.1611 14.2021 14.1746 14.2066 14.1836 14.1931C14.1971 14.1796 14.1926 14.1706 14.1926 14.1661L13.8011 12.2221C13.6436 11.4436 13.9721 10.6561 14.6291 10.2196L16.2806 9.12156C16.2851 9.11706 16.2941 9.11256 16.2941 9.09456C16.2941 9.07656 16.2851 9.07206 16.2806 9.06756L14.6291 7.96956C13.9676 7.52856 13.6436 6.74556 13.8011 5.96706L14.1926 4.02306C14.1926 4.01856 14.1971 4.00506 14.1836 3.99606C14.1701 3.98256 14.1611 3.98706 14.1566 3.98706L12.2126 4.37856C11.4341 4.53606 10.6466 4.20756 10.2101 3.55056L9.11211 1.89906C9.10761 1.89456 9.10311 1.88556 9.08511 1.88556C9.06711 1.88556 9.06261 1.89456 9.05811 1.89906L7.96011 3.55056C7.51911 4.21206 6.73611 4.53606 5.95761 4.37856L4.01361 3.98706C4.00911 3.98706 3.99561 3.98256 3.98661 3.99606C3.97311 4.00956 3.97761 4.01856 3.97761 4.02306L4.36911 5.96706C4.52661 6.74556 4.19811 7.53306 3.54111 7.96956L1.88961 9.06756C1.88511 9.07206 1.87611 9.07656 1.87611 9.09456C1.87611 9.11256 1.88511 9.11706 1.88961 9.12156L3.53661 10.2151C4.19811 10.6561 4.52211 11.4391 4.36461 12.2176L3.97311 14.1616C3.97311 14.1661 3.96861 14.1796 3.98211 14.1886C3.99561 14.2021 4.00461 14.1976 4.00911 14.1976L5.95311 13.8061C6.08361 13.7836 6.21411 13.7701 6.34461 13.7701Z"
        fill="#4905B8"
      />
      <path
        d="M8.38813 11.7224C8.26213 11.7224 8.13163 11.6774 8.03263 11.5874L5.60263 9.44092C5.37763 9.24292 5.35963 8.90092 5.55313 8.68042C5.75113 8.45542 6.09313 8.43742 6.31363 8.63092L8.36113 10.4399L11.7181 7.02442C11.9251 6.81292 12.2671 6.80842 12.4831 7.01992C12.6946 7.22692 12.6991 7.56892 12.4876 7.78492L8.77063 11.5694C8.66713 11.6684 8.52763 11.7224 8.38813 11.7224Z"
        fill="#4905B8"
      />
    </g>
    <defs>
      <clipPath id="clip0_4174_18404">
        <rect width="18" height="18" fill="white" />
      </clipPath>
    </defs>
  </svg>
);

export const DataAssetSVG = () => (
  <svg viewBox="0 0 24 25" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path
      d="M7.79289 5.57452C7.40237 5.96504 7.40237 6.59821 7.79289 6.98873L11.3283 10.5242C11.7189 10.9147 12.352 10.9147 12.7426 10.5242L16.2781 6.98865C16.6686 6.59812 16.6686 5.96496 16.2781 5.57443L12.7426 2.03899C12.3521 1.64846 11.719 1.64846 11.3284 2.03899L7.79289 5.57452ZM12.0354 8.40286L9.91421 6.28163L12.0355 4.16031L14.1568 6.28154L12.0354 8.40286Z"
      fill="#666666"
    />
    <path
      d="M14.2929 13.4887L17.8283 17.0242C18.2189 17.4147 18.852 17.4147 19.2426 17.0242L22.7781 13.4886C23.1686 13.0981 23.1686 12.465 22.7781 12.0744L19.2426 8.53899C18.8521 8.14846 18.219 8.14846 17.8284 8.53899L14.2929 12.0745C13.9024 12.465 13.9024 13.0982 14.2929 13.4887ZM18.5354 14.9029L16.4142 12.7816L18.5355 10.6603L20.6568 12.7815L18.5354 14.9029Z"
      fill="#666666"
    />
    <path
      d="M1.29289 13.4887C0.902369 13.0982 0.902369 12.465 1.29289 12.0745L4.82843 8.53899C5.21895 8.14846 5.85212 8.14846 6.24264 8.53899L9.77809 12.0744C10.1686 12.465 10.1686 13.0981 9.77809 13.4886L6.24255 17.0242C5.85203 17.4147 5.21886 17.4147 4.82834 17.0242L1.29289 13.4887ZM3.41421 12.7816L5.53544 14.9029L7.65676 12.7815L5.53553 10.6603L3.41421 12.7816Z"
      fill="#666666"
    />
    <path
      d="M7.79289 18.5745C7.40237 18.965 7.40237 19.5982 7.79289 19.9887L11.3283 23.5242C11.7189 23.9147 12.352 23.9147 12.7426 23.5242L16.2781 19.9886C16.6686 19.5981 16.6686 18.965 16.2781 18.5744L12.7426 15.039C12.3521 14.6485 11.719 14.6485 11.3284 15.039L7.79289 18.5745ZM12.0354 21.4029L9.91421 19.2816L12.0355 17.1603L14.1568 19.2815L12.0354 21.4029Z"
      fill="#666666"
    />
  </svg>
);

export const ReusabilitySVG = () => (
  <svg viewBox="0 0 24 25" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path
      d="M12.327 2.33614C12.1153 2.26295 11.8852 2.26295 11.6735 2.33614L1.67353 5.79329C1.27191 5.93213 1.0019 6.30964 1.00028 6.73458C0.998658 7.15952 1.26578 7.53908 1.66633 7.68099L11.6663 11.2238C11.8824 11.3004 12.1182 11.3004 12.3342 11.2238L22.3342 7.68099C22.7348 7.53908 23.0019 7.15952 23.0003 6.73458C22.9986 6.30964 22.7286 5.93213 22.327 5.79329L12.327 2.33614ZM12.0003 9.22035L5.02738 6.74996L12.0003 4.33932L18.9732 6.74996L12.0003 9.22035Z"
      fill="#666666"
    />
    <path
      d="M2.33062 9.83739C1.80934 9.65494 1.23886 9.92962 1.05641 10.4509C0.873967 10.9722 1.14864 11.5427 1.66992 11.7251L11.6699 15.2251C11.8838 15.3 12.1168 15.3 12.3306 15.2251L22.3306 11.7251C22.8519 11.5427 23.1266 10.9722 22.9441 10.4509C22.7617 9.92962 22.1912 9.65494 21.6699 9.83739L12.0003 13.2218L2.33062 9.83739Z"
      fill="#666666"
    />
    <path
      d="M1.05641 14.4509C1.23886 13.9296 1.80934 13.6549 2.33062 13.8374L12.0003 17.2218L21.6699 13.8374C22.1912 13.6549 22.7617 13.9296 22.9441 14.4509C23.1266 14.9722 22.8519 15.5427 22.3306 15.7251L12.3306 19.2251C12.1168 19.3 11.8838 19.3 11.6699 19.2251L1.66992 15.7251C1.14864 15.5427 0.873967 14.9722 1.05641 14.4509Z"
      fill="#666666"
    />
    <path
      d="M2.33062 17.8374C1.80934 17.6549 1.23886 17.9296 1.05641 18.4509C0.873967 18.9722 1.14864 19.5427 1.66992 19.7251L11.6699 23.2251C11.8838 23.3 12.1168 23.3 12.3306 23.2251L22.3306 19.7251C22.8519 19.5427 23.1266 18.9722 22.9441 18.4509C22.7617 17.9296 22.1912 17.6549 21.6699 17.8374L12.0003 21.2218L2.33062 17.8374Z"
      fill="#666666"
    />
  </svg>
);

export const DataCoinSVG = () => (
  <svg width="24" height="25" viewBox="0 0 24 25" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path
      d="M12 22.5C17.5229 22.5 22 18.0229 22 12.5C22 6.97715 17.5229 2.5 12 2.5C6.47715 2.5 2 6.97715 2 12.5C2 18.0229 6.47715 22.5 12 22.5Z"
      stroke={PRIMARY_COLOR}
      stroke-width="1.125"
    />
    <path
      d="M14.8284 11.7928L12.7071 9.67146C12.3166 9.28094 11.6834 9.28094 11.2929 9.67146L9.17157 11.7928C8.78105 12.1833 8.78105 12.8165 9.17157 13.207L11.2929 15.3283C11.6834 15.7188 12.3166 15.7188 12.7071 15.3283L14.8284 13.207C15.219 12.8165 15.219 12.1833 14.8284 11.7928Z"
      stroke={PRIMARY_COLOR}
      stroke-width="1.125"
    />
  </svg>
);

export const MedalSVG = () => (
  <svg viewBox="0 0 18 16" fill="none" xmlns="http://www.w3.org/2000/svg">
    <g clip-path="url(#clip0_4168_3536)">
      <path
        d="M9 11.25C11.4853 11.25 13.5 9.17603 13.5 6.61766V1.5H4.5V6.61766C4.5 9.17603 6.51473 11.25 9 11.25Z"
        stroke="currentColor"
        stroke-width="1.125"
      />
      <path
        d="M9 10C10.6568 10 12 8.51099 12 6.67422V3H6V6.67422C6 8.51099 7.34315 10 9 10Z"
        fill="currentColor"
      />
      <path
        fill-rule="evenodd"
        clip-rule="evenodd"
        d="M4.5 7.875V4.125H1.5C1.5 6.62501 3 7.875 4.5 7.875Z"
        stroke="currentColor"
        stroke-width="1.125"
        stroke-linecap="square"
      />
      <path
        fill-rule="evenodd"
        clip-rule="evenodd"
        d="M13.5 7.875V4.125H16.5C16.5 6.62501 15 7.875 13.5 7.875Z"
        stroke="currentColor"
        stroke-width="1.125"
        stroke-linecap="square"
      />
      <path d="M9 12V13.5" stroke="currentColor" stroke-width="1.125" stroke-linecap="square" />
      <path
        d="M5.625 15.75L7.00875 13.5H10.8909L12.375 15.75H5.625Z"
        stroke="currentColor"
        stroke-width="1.125"
      />
    </g>
  </svg>
);

export const BasicIdeasSVG = () => (
  <svg viewBox="0 0 62 66" fill="none" xmlns="http://www.w3.org/2000/svg">
    <g filter="url(#filter0_b_3462_36949)">
      <circle cx="31" cy="31" r="31" fill="white" fill-opacity="0.25" />
      <circle cx="31" cy="31" r="30" stroke="#EBE7F8" stroke-width="2" />
    </g>
    <path d="M43.9153 30.9966H18.082" stroke="white" stroke-width="2" />
    <path d="M35.3047 22.3855L43.9158 30.9966L35.3047 39.6077" stroke="white" stroke-width="2" />
    <defs>
      <filter
        id="filter0_b_3462_36949"
        x="-55"
        y="-55"
        width="172"
        height="172"
        filterUnits="userSpaceOnUse"
        color-interpolation-filters="sRGB"
      >
        <feFlood flood-opacity="0" result="BackgroundImageFix" />
        <feGaussianBlur in="BackgroundImageFix" stdDeviation="27.5" />
        <feComposite in2="SourceAlpha" operator="in" result="effect1_backgroundBlur_3462_36949" />
        <feBlend
          mode="normal"
          in="SourceGraphic"
          in2="effect1_backgroundBlur_3462_36949"
          result="shape"
        />
      </filter>
    </defs>
  </svg>
);

export const UsecaseBaseSArrow = () => (
  <svg viewBox="0 0 42 20" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path d="M40 10.1113H0" stroke="white" stroke-width="3" />
    <path d="M31 1.5L39.6111 10.1111L31 18.7222" stroke="white" stroke-width="3" />
  </svg>
);

export const UsecaseBaseSquareArrow = () => (
  <svg viewBox="0 0 72 33" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path d="M70 16.5H0" stroke="white" stroke-width="3" />
    <path d="M54.25 1.5L69.3194 16.5L54.25 31.5" stroke="white" stroke-width="3" />
  </svg>
);

export const EDMLogoSVG = () => (
  <svg viewBox="0 0 342 46" fill="none" xmlns="http://www.w3.org/2000/svg">
    <rect y="13.6558" width="18.6667" height="18.6667" fill="#FF18B4" />
    <g clip-path="url(#clip0_3577_49241)">
      <path
        d="M174.054 13.2484C172.358 12.3357 170.172 11.2439 167.806 10.2009C165.098 9.02749 162.618 8.03339 160.628 7.34892L159.812 8.4897C161.721 9.56529 164.103 10.755 167.023 12.0587C169.764 13.2973 172.113 14.1773 174.103 14.8617L174.071 13.2647L174.054 13.2484ZM173.907 4.26882C173.956 2.63914 173.239 1.36799 171.281 0.993164H166.175C165.767 0.993164 165.375 1.09094 165.016 1.28651C164.657 1.48207 164.347 1.75911 164.119 2.08505L163.434 3.11175C165.473 3.84511 167.627 4.70884 169.796 5.67035C171.167 6.28963 172.668 6.9578 173.94 7.59337L173.891 4.26882H173.907ZM173.907 45.3694L173.826 21.2827C170.743 20.2886 167.708 19.1315 164.755 17.8115C163.369 17.1922 160.106 15.7092 156.778 13.8513L150.937 21.8205H150.611L142.03 9.02749L137.821 2.72063C137.478 2.19913 136.989 1.75911 136.434 1.46577C135.879 1.17243 135.259 1.00946 134.623 1.00946H130.496C129.745 1.00946 129.011 1.3028 128.473 1.8406C127.934 2.37839 127.641 3.09545 127.641 3.8614V45.3694H137.511V22.5538C137.511 22.3909 137.56 22.2279 137.657 22.0812C137.755 21.9509 137.902 21.8368 138.049 21.7879C138.196 21.739 138.375 21.739 138.538 21.7879C138.702 21.8368 138.832 21.9346 138.93 22.0812L142.03 26.2695L146.418 32.2504C146.581 32.4623 146.777 32.6416 147.005 32.7556C147.234 32.8697 147.495 32.9349 147.756 32.9349H153.727C153.988 32.9349 154.249 32.8697 154.494 32.7556C154.738 32.6416 154.934 32.4623 155.097 32.2504L162.569 21.9183C162.667 21.7879 162.814 21.6738 162.977 21.6249C163.14 21.576 163.32 21.576 163.466 21.6249C163.63 21.6738 163.76 21.7716 163.874 21.9183C163.972 22.0486 164.021 22.2116 164.037 22.3909V45.3857H173.907V45.3694Z"
        fill="#180562"
      />
      <path
        d="M124.366 23.1731C124.464 27.2799 123.501 31.3378 121.576 34.972C121.136 35.7706 120.63 36.5365 120.059 37.2699C118.966 38.704 117.661 39.9588 116.193 41.0181C115.328 41.6374 114.414 42.1915 113.468 42.6641C109.912 44.4568 105.686 45.3531 100.743 45.3368H85.832V35.852H100.808C104.968 35.852 108.215 34.7276 110.515 32.4786C112.816 30.2296 113.974 27.1495 113.974 23.2057C113.974 19.2619 112.865 16.1818 110.646 13.9328C108.427 11.7002 105.295 10.5594 101.233 10.5105H97.3661C97.0072 10.5105 96.6646 10.6572 96.4199 10.9016C96.1752 11.1461 96.0283 11.4883 96.0283 11.8468V33.6357H85.8647V10.5431H85.832V3.84511C85.832 3.09545 86.1257 2.3621 86.6641 1.8243C87.2024 1.28651 87.9202 0.993164 88.687 0.993164H101.673C106.42 0.993164 110.499 1.88949 113.892 3.68214C114.692 4.10585 115.458 4.56217 116.176 5.08366C117.645 6.12666 118.95 7.39781 120.043 8.84823C120.646 9.64677 121.185 10.4942 121.658 11.3742C123.534 15.0247 124.448 19.0826 124.35 23.1731H124.366Z"
        fill="#6510F9"
      />
      <path
        style="mix-blend-mode:overlay"
        d="M124.366 23.1731C124.464 27.2799 123.501 31.3378 121.576 34.972C121.136 35.7706 120.63 36.5365 120.059 37.2699C118.966 38.704 117.661 39.9588 116.193 41.0181C115.328 41.6374 114.414 42.1915 113.468 42.6641C109.912 44.4568 105.686 45.3531 100.743 45.3368H85.832V35.852H100.808C104.968 35.852 108.215 34.7276 110.515 32.4786C112.816 30.2296 113.974 27.1495 113.974 23.2057C113.974 19.2619 112.865 16.1818 110.646 13.9328C108.427 11.7002 105.295 10.5594 101.233 10.5105H97.3661C97.0072 10.5105 96.6646 10.6572 96.4199 10.9016C96.1752 11.1461 96.0283 11.4883 96.0283 11.8468V33.6357H85.8647V10.5431H85.832V3.84511C85.832 3.09545 86.1257 2.3621 86.6641 1.8243C87.2024 1.28651 87.9202 0.993164 88.687 0.993164H101.673C106.42 0.993164 110.499 1.88949 113.892 3.68214C114.692 4.10585 115.458 4.56217 116.176 5.08366C117.645 6.12666 118.95 7.39781 120.043 8.84823C120.646 9.64677 121.185 10.4942 121.658 11.3742C123.534 15.0247 124.448 19.0826 124.35 23.1731H124.366Z"
        fill="url(#paint0_linear_3577_49241)"
      />
      <path
        d="M150.435 7.49341C148.673 5.92891 147.678 4.39701 148.249 3.09327C148.967 1.47989 151.3 1.23543 155.819 2.26213C160.289 3.38661 164.645 4.90222 168.838 6.80894C173.079 8.61789 177.142 10.818 180.975 13.3766C184.793 16.0329 186.18 17.9234 185.462 19.553C184.744 21.1664 182.411 21.4109 177.876 20.3842C173.406 19.2597 169.05 17.7278 164.857 15.8048C162.687 14.8596 154.498 11.1113 150.419 7.49341H150.435ZM152.214 4.15256C152.083 4.15256 151.936 4.16886 151.822 4.25034C151.708 4.31553 151.61 4.42961 151.561 4.55998C151.512 4.69036 151.496 4.82073 151.512 4.9674C151.528 5.11407 151.61 5.22815 151.708 5.32593C153.698 7.18377 158.299 10.2639 165.868 13.5721C173.438 16.8804 178.822 18.2493 181.514 18.5101C181.661 18.5101 181.791 18.5101 181.922 18.4286C182.036 18.3634 182.134 18.2493 182.199 18.1189C182.248 17.9886 182.264 17.8419 182.248 17.7115C182.215 17.5811 182.15 17.4508 182.036 17.353C180.045 15.5277 175.429 12.4476 167.875 9.10679C160.322 5.76595 154.922 4.41331 152.23 4.16886L152.214 4.15256Z"
        fill="#180562"
      />
      <path
        style="mix-blend-mode:overlay"
        d="M174.054 13.2484C172.358 12.3357 170.172 11.2439 167.806 10.2009C165.098 9.02749 162.618 8.03339 160.628 7.34892L159.812 8.4897C161.721 9.56529 164.103 10.755 167.023 12.0587C169.764 13.2973 172.113 14.1773 174.103 14.8617L174.071 13.2647L174.054 13.2484ZM173.907 4.26882C173.956 2.63914 173.239 1.36799 171.281 0.993164H166.175C165.767 0.993164 165.375 1.09094 165.016 1.28651C164.657 1.48207 164.347 1.75911 164.119 2.08505L163.434 3.11175C165.473 3.84511 167.627 4.70884 169.796 5.67035C171.167 6.28963 172.668 6.9578 173.94 7.59337L173.891 4.26882H173.907ZM173.907 45.3694L173.826 21.2827C170.743 20.2886 167.708 19.1315 164.755 17.8115C163.369 17.1922 160.106 15.7092 156.778 13.8513L150.937 21.8205H150.611L142.03 9.02749L137.821 2.72063C137.478 2.19913 136.989 1.75911 136.434 1.46577C135.879 1.17243 135.259 1.00946 134.623 1.00946H130.496C129.745 1.00946 129.011 1.3028 128.473 1.8406C127.934 2.37839 127.641 3.09545 127.641 3.8614V45.3694H137.511V22.5538C137.511 22.3909 137.56 22.2279 137.657 22.0812C137.755 21.9509 137.902 21.8368 138.049 21.7879C138.196 21.739 138.375 21.739 138.538 21.7879C138.702 21.8368 138.832 21.9346 138.93 22.0812L142.03 26.2695L146.418 32.2504C146.581 32.4623 146.777 32.6416 147.005 32.7556C147.234 32.8697 147.495 32.9349 147.756 32.9349H153.727C153.988 32.9349 154.249 32.8697 154.494 32.7556C154.738 32.6416 154.934 32.4623 155.097 32.2504L162.569 21.9183C162.667 21.7879 162.814 21.6738 162.977 21.6249C163.14 21.576 163.32 21.576 163.466 21.6249C163.63 21.6738 163.76 21.7716 163.874 21.9183C163.972 22.0486 164.021 22.2116 164.037 22.3909V45.3857H173.907V45.3694Z"
        fill="url(#paint1_linear_3577_49241)"
      />
      <path
        style="mix-blend-mode:overlay"
        d="M150.435 7.49341C148.673 5.92891 147.678 4.39701 148.249 3.09327C148.967 1.47989 151.3 1.23543 155.819 2.26213C160.289 3.38661 164.645 4.90222 168.838 6.80894C173.079 8.61789 177.142 10.818 180.975 13.3766C184.793 16.0329 186.18 17.9234 185.462 19.553C184.744 21.1664 182.411 21.4109 177.876 20.3842C173.406 19.2597 169.05 17.7278 164.857 15.8048C162.687 14.8596 154.498 11.1113 150.419 7.49341H150.435ZM152.214 4.15256C152.083 4.15256 151.936 4.16886 151.822 4.25034C151.708 4.31553 151.61 4.42961 151.561 4.55998C151.512 4.69036 151.496 4.82073 151.512 4.9674C151.528 5.11407 151.61 5.22815 151.708 5.32593C153.698 7.18377 158.299 10.2639 165.868 13.5721C173.438 16.8804 178.822 18.2493 181.514 18.5101C181.661 18.5101 181.791 18.5101 181.922 18.4286C182.036 18.3634 182.134 18.2493 182.199 18.1189C182.248 17.9886 182.264 17.8419 182.248 17.7115C182.215 17.5811 182.15 17.4508 182.036 17.353C180.045 15.5277 175.429 12.4476 167.875 9.10679C160.322 5.76595 154.922 4.41331 152.23 4.16886L152.214 4.15256Z"
        fill="url(#paint2_linear_3577_49241)"
      />
      <path
        d="M173.437 21.353C175.476 21.353 177.124 19.707 177.124 17.6699C177.124 15.6328 175.476 13.9868 173.437 13.9868C171.398 13.9868 169.75 15.6328 169.75 17.6699C169.75 19.707 171.398 21.353 173.437 21.353Z"
        fill="#FF9E00"
      />
      <path
        style="mix-blend-mode:overlay"
        d="M173.437 21.353C175.476 21.353 177.124 19.707 177.124 17.6699C177.124 15.6328 175.476 13.9868 173.437 13.9868C171.398 13.9868 169.75 15.6328 169.75 17.6699C169.75 19.707 171.398 21.353 173.437 21.353Z"
        fill="url(#paint3_linear_3577_49241)"
      />
      <path
        d="M52.4055 11.635V18.3167H71.0526V28.0459H52.4055V34.695C52.4055 34.809 52.4219 34.9394 52.4708 35.0535C52.5197 35.1676 52.585 35.2654 52.6666 35.3468C52.7481 35.4283 52.8623 35.4935 52.9602 35.5424C53.0744 35.5913 53.1886 35.6076 53.3191 35.6076H82.1299V45.3368H45.7983C45.3905 45.3368 44.9826 45.2553 44.6074 45.0923C44.2322 44.9294 43.8896 44.7012 43.5959 44.4079C43.3023 44.1145 43.0739 43.7723 42.9107 43.3975C42.7476 43.0552 42.666 42.6478 42.666 42.2404V4.08956C42.666 3.25842 42.9923 2.47617 43.5796 1.90579C44.1669 1.3191 44.95 0.993164 45.7657 0.993164H82.1462V10.7224H53.3354C53.2212 10.7224 53.0907 10.7387 52.9765 10.7875C52.8623 10.8364 52.7645 10.9016 52.6829 10.9831C52.6013 11.0646 52.5361 11.1624 52.4871 11.2764C52.4382 11.3905 52.4219 11.5046 52.4219 11.635H52.4055Z"
        fill="#6100AD"
      />
      <path
        style="mix-blend-mode:overlay"
        d="M52.4055 11.635V18.3167H71.0526V28.0459H52.4055V34.695C52.4055 34.809 52.4219 34.9394 52.4708 35.0535C52.5197 35.1676 52.585 35.2654 52.6666 35.3468C52.7481 35.4283 52.8623 35.4935 52.9602 35.5424C53.0744 35.5913 53.1886 35.6076 53.3191 35.6076H82.1299V45.3368H45.7983C45.3905 45.3368 44.9826 45.2553 44.6074 45.0923C44.2322 44.9294 43.8896 44.7012 43.5959 44.4079C43.3023 44.1145 43.0739 43.7723 42.9107 43.3975C42.7476 43.0552 42.666 42.6478 42.666 42.2404V4.08956C42.666 3.25842 42.9923 2.47617 43.5796 1.90579C44.1669 1.3191 44.95 0.993164 45.7657 0.993164H82.1462V10.7224H53.3354C53.2212 10.7224 53.0907 10.7387 52.9765 10.7875C52.8623 10.8364 52.7645 10.9016 52.6829 10.9831C52.6013 11.0646 52.5361 11.1624 52.4871 11.2764C52.4382 11.3905 52.4219 11.5046 52.4219 11.635H52.4055Z"
        fill="url(#paint4_linear_3577_49241)"
      />
      <path
        d="M52.4055 11.635V18.3167H55.9294V28.0459H52.4055V34.695C52.4055 34.809 52.4219 34.9394 52.4708 35.0535C52.5197 35.1676 52.585 35.2654 52.6666 35.3468C52.7481 35.4283 52.8623 35.4935 52.9602 35.5424C53.0744 35.5913 53.1886 35.6076 53.3191 35.6076H55.9131V45.3368H45.7983C45.3905 45.3368 44.9826 45.2553 44.6074 45.0923C44.2322 44.9294 43.8896 44.7012 43.5959 44.4079C43.3023 44.1145 43.0739 43.7723 42.9107 43.3975C42.7476 43.0552 42.666 42.6478 42.666 42.2404V4.08956C42.666 3.25842 42.9923 2.47617 43.5796 1.90579C44.1669 1.3191 44.95 0.993164 45.7657 0.993164H55.9457V10.7224H53.3518C53.2376 10.7224 53.107 10.7387 52.9928 10.7875C52.8786 10.8364 52.7808 10.9016 52.6992 10.9831C52.6176 11.0646 52.5524 11.1624 52.5034 11.2764C52.4545 11.3905 52.4382 11.5046 52.4382 11.635H52.4055Z"
        fill="#F9A300"
      />
      <path
        style="mix-blend-mode:overlay"
        d="M52.4055 11.635V18.3167H55.9294V28.0459H52.4055V34.695C52.4055 34.809 52.4219 34.9394 52.4708 35.0535C52.5197 35.1676 52.585 35.2654 52.6666 35.3468C52.7481 35.4283 52.8623 35.4935 52.9602 35.5424C53.0744 35.5913 53.1886 35.6076 53.3191 35.6076H55.9131V45.3368H45.7983C45.3905 45.3368 44.9826 45.2553 44.6074 45.0923C44.2322 44.9294 43.8896 44.7012 43.5959 44.4079C43.3023 44.1145 43.0739 43.7723 42.9107 43.3975C42.7476 43.0552 42.666 42.6478 42.666 42.2404V4.08956C42.666 3.25842 42.9923 2.47617 43.5796 1.90579C44.1669 1.3191 44.95 0.993164 45.7657 0.993164H55.9457V10.7224H53.3518C53.2376 10.7224 53.107 10.7387 52.9928 10.7875C52.8786 10.8364 52.7808 10.9016 52.6992 10.9831C52.6176 11.0646 52.5524 11.1624 52.5034 11.2764C52.4545 11.3905 52.4382 11.5046 52.4382 11.635H52.4055Z"
        fill="url(#paint5_linear_3577_49241)"
      />
      <path
        d="M142.035 9.02749V26.3184L138.935 22.1301C138.837 21.9998 138.69 21.902 138.544 21.8368C138.38 21.7879 138.217 21.7879 138.054 21.8368C137.891 21.8857 137.761 21.9835 137.663 22.1301C137.565 22.2605 137.516 22.4235 137.516 22.6027V45.3694H127.662V3.8614C127.662 3.48658 127.727 3.11175 127.874 2.76952C128.021 2.42728 128.233 2.10135 128.494 1.8406C128.755 1.57985 129.081 1.36799 129.424 1.22132C129.75 1.07465 130.126 0.993164 130.501 0.993164H134.628C135.264 0.993164 135.884 1.13984 136.439 1.44947C136.994 1.74282 137.467 2.18283 137.826 2.70433L142.035 9.02749Z"
        fill="#FE01B8"
      />
      <path
        d="M124.35 23.1725C124.448 27.2793 123.485 31.3373 121.56 34.9714C121.12 35.77 120.614 36.5359 120.043 37.2693V8.84766C120.647 9.6462 121.185 10.4936 121.658 11.3737C123.518 15.0241 124.448 19.082 124.35 23.1725Z"
        fill="#FE01B8"
      />
      <path
        style="mix-blend-mode:overlay"
        d="M142.035 9.02749V26.3184L138.935 22.1301C138.837 21.9998 138.69 21.902 138.544 21.8368C138.38 21.7879 138.217 21.7879 138.054 21.8368C137.891 21.8857 137.761 21.9835 137.663 22.1301C137.565 22.2605 137.516 22.4235 137.516 22.6027V45.3694H127.662V3.8614C127.662 3.48658 127.727 3.11175 127.874 2.76952C128.021 2.42728 128.233 2.10135 128.494 1.8406C128.755 1.57985 129.081 1.36799 129.424 1.22132C129.75 1.07465 130.126 0.993164 130.501 0.993164H134.628C135.264 0.993164 135.884 1.13984 136.439 1.44947C136.994 1.74282 137.467 2.18283 137.826 2.70433L142.035 9.02749Z"
        fill="url(#paint6_linear_3577_49241)"
      />
      <path
        style="mix-blend-mode:overlay"
        d="M124.35 23.1725C124.448 27.2793 123.485 31.3373 121.56 34.9714C121.12 35.77 120.614 36.5359 120.043 37.2693V8.84766C120.647 9.6462 121.185 10.4936 121.658 11.3737C123.518 15.0241 124.448 19.082 124.35 23.1725Z"
        fill="url(#paint7_linear_3577_49241)"
      />
    </g>
    <path
      d="M207.115 18.1288V0.796875H217.085V3.3319H209.739V8.04376H216.643V10.5788H209.739V15.6213H217.361V18.1563H207.115V18.1288Z"
      fill="#4905B8"
    />
    <path
      d="M219.654 18.1288V0.796875H222.885L228.381 13.4445V0.796875H230.977V18.1288H227.746L222.25 5.48117V18.1288H219.654Z"
      fill="#4905B8"
    />
    <path
      d="M237.575 18.1288V3.3319H232.797V0.796875H244.976V3.3319H240.198V18.1288H237.575Z"
      fill="#4905B8"
    />
    <path
      d="M246.826 18.1288V0.796875H256.796V3.3319H249.477V8.04376H256.382V10.5788H249.477V15.6213H257.1V18.1563H246.854L246.826 18.1288Z"
      fill="#4905B8"
    />
    <path
      d="M259.34 18.1288V0.796875H265.471C267.238 0.796875 268.315 0.989758 269.31 1.95417C270.166 2.78081 270.635 4.15854 270.635 5.7016C270.635 7.24466 270.138 8.40197 269.42 9.4766C269.006 10.0828 268.343 10.937 267.984 11.3779L271.353 18.1288H268.315L265.222 11.7912H261.991V18.1288H259.367H259.34ZM266.382 9.25616C266.658 8.89795 267.017 8.42952 267.238 8.07131C267.68 7.38244 267.929 6.66602 267.929 5.75671C267.929 4.93007 267.735 4.24121 267.266 3.82789C266.796 3.44212 266.299 3.3319 265.195 3.3319H261.963V9.25616H266.382Z"
      fill="#4905B8"
    />
    <path
      d="M273.094 18.1288V0.796875H279.059C280.661 0.796875 281.765 1.2102 282.622 2.20216C283.423 3.16658 283.809 4.62697 283.809 6.19759C283.809 7.7682 283.45 9.36638 282.539 10.441C281.683 11.4054 280.523 11.7636 279.142 11.8739C278.286 11.929 277.153 11.929 275.717 11.929V18.1288H273.094ZM278.866 9.31127C279.749 9.25616 280.274 8.98061 280.633 8.45707C280.992 7.93353 281.13 7.162 281.13 6.19759C281.13 5.23317 280.965 4.40654 280.55 3.91056C280.136 3.41457 279.667 3.27679 278.755 3.27679H275.745V9.33882C276.933 9.33882 278.037 9.33883 278.893 9.28372L278.866 9.31127Z"
      fill="#4905B8"
    />
    <path
      d="M286.045 18.1288V0.796875H292.176C293.943 0.796875 295.02 0.989758 296.015 1.95417C296.871 2.78081 297.34 4.15854 297.34 5.7016C297.34 7.24466 296.843 8.40197 296.125 9.4766C295.711 10.0828 295.048 10.937 294.689 11.3779L298.058 18.1288H295.02L291.927 11.7912H288.696V18.1288H286.073H286.045ZM293.087 9.25616C293.363 8.89795 293.722 8.42952 293.943 8.07131C294.385 7.38244 294.634 6.66602 294.634 5.75671C294.634 4.93007 294.44 4.24121 293.971 3.82789C293.502 3.44212 293.004 3.3319 291.9 3.3319H288.669V9.25616H293.087Z"
      fill="#4905B8"
    />
    <path d="M299.799 18.1288V0.796875H302.422V18.1288H299.799Z" fill="#4905B8" />
    <path
      d="M305.015 15.1517C306.479 15.5099 308.495 15.9508 310.014 15.9508C311.118 15.9508 311.781 15.7854 312.251 15.3446C312.72 14.9037 312.886 14.2148 312.886 13.4984C312.886 12.8647 312.748 12.4513 312.416 12.0656C312.085 11.6798 311.533 11.4318 310.704 11.046L308.191 9.91631C307.224 9.47543 306.589 9.14478 306.037 8.59369C305.236 7.7946 304.877 6.66485 304.877 5.25956C304.877 3.60628 305.264 2.44899 306.285 1.51213C307.197 0.657936 308.522 0.4375 310.041 0.4375C311.643 0.4375 313.687 0.905927 314.985 1.23658V3.85428C313.714 3.49607 311.367 2.94497 310.041 2.94497C309.075 2.94497 308.495 3.08275 308.081 3.55118C307.722 3.9645 307.556 4.54314 307.556 5.1769C307.556 5.81066 307.639 6.30664 307.97 6.6373C308.301 6.96795 308.716 7.18839 309.461 7.5466L311.975 8.67635C313.052 9.17233 313.825 9.5581 314.405 10.1643C315.123 10.9083 315.537 12.038 315.537 13.4158C315.537 14.9588 315.15 16.1437 314.184 17.1081C313.217 18.0725 312.057 18.4307 310.014 18.4307C308.44 18.4307 306.313 18.0174 305.015 17.7143V15.0966V15.1517Z"
      fill="#4905B8"
    />
    <path
      d="M317.996 18.1288V0.796875H327.966V3.3319H320.647V8.04376H327.552V10.5788H320.647V15.6213H328.27V18.1563H318.024L317.996 18.1288Z"
      fill="#4905B8"
    />
    <path
      d="M207.115 28.209H212.169C214.296 28.209 215.787 28.6223 216.836 30.0276C217.886 31.4053 218.411 33.4995 218.411 36.806C218.411 40.1126 217.803 42.4272 216.477 43.8876C215.345 45.1275 214.019 45.5409 212.059 45.5409H207.115V28.209ZM212.086 43.0058C213.495 43.0058 214.351 42.565 214.958 41.4903C215.566 40.4433 215.732 38.7624 215.732 36.806C215.732 34.8497 215.594 32.9484 214.876 31.8738C214.24 30.9369 213.329 30.744 212.169 30.744H209.739V43.0334H212.086V43.0058Z"
      fill="#262626"
    />
    <path
      d="M219.211 45.5409L224.403 28.209H227.855L233.047 45.5409H230.175L229.153 41.9312H223.077L222.055 45.5409H219.211ZM228.463 39.4513L226.088 31.1022L223.713 39.4513H228.463Z"
      fill="#262626"
    />
    <path
      d="M236.389 45.5409V30.744H231.611V28.209H243.79V30.744H239.013V45.5409H236.389Z"
      fill="#262626"
    />
    <path
      d="M242.354 45.5409L247.546 28.209H250.998L256.19 45.5409H253.317L252.296 41.9312H246.22L245.198 45.5409H242.354ZM251.605 39.4513L249.23 31.1022L246.855 39.4513H251.605Z"
      fill="#262626"
    />
    <path
      d="M262.569 45.5409V28.209H266.131L269.583 38.542L273.008 28.209H276.515V45.5409H273.947V32.5075L270.743 42.0965H268.313L265.109 32.5075V45.5409H262.541H262.569Z"
      fill="#262626"
    />
    <path
      d="M278.172 45.5409L283.364 28.209H286.816L292.008 45.5409H289.136L288.114 41.9312H282.038L281.016 45.5409H278.172ZM287.424 39.4513L285.049 31.1022L282.673 39.4513H287.424Z"
      fill="#262626"
    />
    <path
      d="M293.666 45.5409V28.209H299.631C301.233 28.209 302.338 28.6223 303.194 29.6143C303.995 30.5787 304.381 32.0391 304.381 33.6097C304.381 35.1803 304.022 36.7785 303.111 37.8531C302.255 38.8175 301.095 39.1757 299.714 39.286C298.858 39.3411 297.726 39.3411 296.29 39.3411V45.5409H293.666ZM299.438 36.7234C300.322 36.6683 300.846 36.3927 301.205 35.8692C301.564 35.3456 301.703 34.5741 301.703 33.6097C301.703 32.6453 301.537 31.8186 301.123 31.3227C300.708 30.8267 300.239 30.6889 299.328 30.6889H296.317V36.7509C297.505 36.7509 298.609 36.7509 299.466 36.6958L299.438 36.7234Z"
      fill="#262626"
    />
    <defs>
      <linearGradient
        id="paint0_linear_3577_49241"
        x1="80.9541"
        y1="-7.22043"
        x2="136.648"
        y2="79.793"
        gradientUnits="userSpaceOnUse"
      >
        <stop stop-color="white" />
        <stop offset="1" />
      </linearGradient>
      <linearGradient
        id="paint1_linear_3577_49241"
        x1="138.375"
        y1="5.06737"
        x2="183.074"
        y2="74.1113"
        gradientUnits="userSpaceOnUse"
      >
        <stop stop-color="white" />
        <stop offset="1" />
      </linearGradient>
      <linearGradient
        id="paint2_linear_3577_49241"
        x1="155.591"
        y1="-6.08183"
        x2="200.306"
        y2="62.9622"
        gradientUnits="userSpaceOnUse"
      >
        <stop stop-color="white" />
        <stop offset="1" />
      </linearGradient>
      <linearGradient
        id="paint3_linear_3577_49241"
        x1="171.153"
        y1="13.9216"
        x2="177.701"
        y2="24.6837"
        gradientUnits="userSpaceOnUse"
      >
        <stop stop-color="white" />
        <stop offset="1" />
      </linearGradient>
      <linearGradient
        id="paint4_linear_3577_49241"
        x1="47.3319"
        y1="-1.7447"
        x2="90.7919"
        y2="67.1021"
        gradientUnits="userSpaceOnUse"
      >
        <stop stop-color="white" />
        <stop offset="1" />
      </linearGradient>
      <linearGradient
        id="paint5_linear_3577_49241"
        x1="33.3343"
        y1="-1.33728"
        x2="72.741"
        y2="56.6368"
        gradientUnits="userSpaceOnUse"
      >
        <stop stop-color="white" />
        <stop offset="1" />
      </linearGradient>
      <linearGradient
        id="paint6_linear_3577_49241"
        x1="118.412"
        y1="-1.2069"
        x2="144.082"
        y2="43.2418"
        gradientUnits="userSpaceOnUse"
      >
        <stop stop-color="white" />
        <stop offset="1" />
      </linearGradient>
      <linearGradient
        id="paint7_linear_3577_49241"
        x1="109.178"
        y1="4.12158"
        x2="134.848"
        y2="48.5703"
        gradientUnits="userSpaceOnUse"
      >
        <stop stop-color="white" />
        <stop offset="1" />
      </linearGradient>
      <clipPath id="clip0_3577_49241">
        <rect
          width="142.449"
          height="43.9998"
          fill="white"
          transform="translate(42.666 0.993164)"
        />
      </clipPath>
    </defs>
  </svg>
);
export const CommunityHouseRoofSVG = () => (
  <svg viewBox="0 0 1562 112" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path d="M1561 107L782.996 6L1 105.918" stroke="#D8E4F0" stroke-width="10" />
  </svg>
);

export const CommunityHouseBoxSVG = () => (
  <svg viewBox="0 0 1554 103" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path d="M777 0L1554 103H0L777 0Z" fill="#ECF0F6" />
  </svg>
);
export const CommunityHouseContentSVG1 = () => (
  <svg viewBox="0 0 68 64" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path
      d="M12.9051 0H34.1062C34.3254 0.000130713 34.5406 0.0585381 34.7298 0.169257C34.9191 0.279976 35.0756 0.439038 35.1834 0.630199L45.6373 19.1367C45.7439 19.3251 45.7994 19.5382 45.7983 19.7547C45.7972 19.9713 45.7396 20.1838 45.6311 20.3711L35.1859 38.3801C35.0771 38.5679 34.9211 38.7238 34.7334 38.8322C34.5456 38.9406 34.3328 38.9977 34.1161 38.9979H12.9051C12.6897 38.9979 12.4782 38.9415 12.2912 38.8345C12.1042 38.7274 11.9484 38.5734 11.839 38.3876L1.06693 20.1304C0.954069 19.9392 0.894531 19.7211 0.894531 19.499C0.894531 19.2768 0.954069 19.0587 1.06693 18.8675L11.839 0.610351C11.9483 0.424703 12.1039 0.270784 12.2907 0.163758C12.4774 0.056732 12.6887 0.000292604 12.9038 0H12.9051Z"
      fill="#4372CE"
    />
    <g filter="url(#filter0_b_6439_11588)">
      <path
        d="M27.9134 17.9961H53.4674C53.6559 17.9961 53.8411 18.046 54.0043 18.1407C54.1675 18.2353 54.3029 18.3715 54.3968 18.5353L66.9824 40.4736C67.0771 40.6382 67.1265 40.8251 67.1255 41.0151C67.1246 41.2051 67.0734 41.3915 66.9771 41.5552L54.3989 62.9103C54.3042 63.0712 54.1693 63.2045 54.0074 63.2972C53.8456 63.3899 53.6624 63.4387 53.4759 63.4387H27.9134C27.7283 63.4386 27.5464 63.3904 27.3854 63.2989C27.2244 63.2075 27.0898 63.0758 26.9947 62.9167L14.0242 41.2716C13.924 41.1046 13.8711 40.9134 13.8711 40.7185C13.8711 40.5236 13.924 40.3324 14.0242 40.1653L26.9947 18.5181C27.0899 18.3592 27.2246 18.2278 27.3856 18.1365C27.5466 18.0452 27.7284 17.9972 27.9134 17.9972V17.9961Z"
        fill="url(#paint0_linear_6439_11588)"
        fill-opacity="0.2"
      />
      <path
        d="M53.5292 19.0326L53.5294 19.0329L66.115 40.9712L66.1155 40.9721C66.1221 40.9835 66.1256 40.9967 66.1256 41.0102C66.1255 41.0236 66.1219 41.0368 66.1152 41.0481L53.5373 62.4028L53.5372 62.403C53.5306 62.4142 53.5214 62.4232 53.5106 62.4294C53.4998 62.4355 53.4877 62.4387 53.4756 62.4387H27.9142C27.9021 62.4387 27.8901 62.4356 27.8794 62.4295C27.8687 62.4234 27.8595 62.4145 27.8529 62.4034L27.8525 62.4027L14.882 40.7576L14.8818 40.7574C14.8749 40.7458 14.8711 40.7323 14.8711 40.7185C14.8711 40.7047 14.8749 40.6912 14.8818 40.6796L14.882 40.6793L27.8523 19.0324C27.8523 19.0324 27.8523 19.0323 27.8523 19.0323C27.8589 19.0213 27.8681 19.0124 27.8788 19.0064C27.8896 19.0003 27.9015 18.9972 27.9136 18.9972L28.9134 18.997V18.9961H53.4672C53.4795 18.9961 53.4917 18.9993 53.5025 19.0057C53.5134 19.012 53.5227 19.0212 53.5292 19.0326Z"
        stroke="white"
        stroke-width="2"
      />
    </g>
    <path
      d="M44.2461 40.9356L46.1054 38.4648L47.9646 40.9356H46.7904V43.4063H45.4204V40.9356H44.2461Z"
      fill="white"
      stroke="white"
      stroke-width="1.125"
      stroke-linecap="square"
    />
    <path
      d="M32.2394 38.783C33.2557 38.7109 33.9826 38.6539 35.6815 38.493L34.4165 41.6422C33.6615 41.0904 32.847 40.9613 32.2364 40.9613C30.462 40.9613 29.0243 42.3987 29.0243 44.167C29.0243 45.9388 30.462 47.3731 32.2364 47.3731C35.7822 47.3731 36.7417 41.1787 36.7543 41.1222L36.7699 41.0778C37.7293 36.0878 40.0112 33.217 43.7448 32.2865C48.5239 31.0982 53.306 33.7082 54.64 38.2348C55.31 40.4978 55.0618 42.8779 53.9292 44.9361C52.8092 47.0105 50.9371 48.5044 48.6845 49.1727C46.4036 49.8536 42.147 49.4753 39.6769 46.3135L40.432 43.354C42.0302 47.184 46.0699 47.704 48.0739 47.1114C49.7733 46.604 51.1823 45.4722 52.0254 43.9214C52.8686 42.3705 53.0735 40.5704 52.564 38.8748C51.5633 35.4482 47.9168 33.4903 44.2703 34.4012C42.4677 34.8526 39.9412 36.0691 38.9092 41.4657C38.8212 42.0457 37.5567 49.5449 32.2394 49.5449C30.8105 49.5445 29.4398 48.9779 28.4263 47.9688C27.9264 47.4697 27.5298 46.8767 27.2589 46.2238C26.988 45.571 26.8483 44.871 26.8477 44.164C26.8472 41.1913 29.1723 39.0322 32.2389 38.783H32.2394Z"
      fill="white"
    />
    <defs>
      <filter
        id="filter0_b_6439_11588"
        x="2.87109"
        y="6.99609"
        width="75.2539"
        height="67.4414"
        filterUnits="userSpaceOnUse"
        color-interpolation-filters="sRGB"
      >
        <feFlood flood-opacity="0" result="BackgroundImageFix" />
        <feGaussianBlur in="BackgroundImageFix" stdDeviation="5.5" />
        <feComposite in2="SourceAlpha" operator="in" result="effect1_backgroundBlur_6439_11588" />
        <feBlend
          mode="normal"
          in="SourceGraphic"
          in2="effect1_backgroundBlur_6439_11588"
          result="shape"
        />
      </filter>
      <linearGradient
        id="paint0_linear_6439_11588"
        x1="40.4983"
        y1="17.9961"
        x2="40.4983"
        y2="63.4387"
        gradientUnits="userSpaceOnUse"
      >
        <stop stop-color="#206AF2" />
        <stop offset="1" stop-color="#206AF2" />
      </linearGradient>
    </defs>
  </svg>
);
export const CommunityHouseContentSVG2 = () => (
  <svg viewBox="0 0 59 65" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path
      d="M17.7014 14.9922C8.22517 14.9922 0.546875 12.3063 0.546875 8.99219V20.9922C0.546875 24.3063 8.22517 26.9922 17.7014 26.9922C27.1776 26.9922 34.8559 24.3063 34.8559 20.9922V8.99219C34.8559 12.3063 27.1776 14.9922 17.7014 14.9922Z"
      fill="#4372CE"
    />
    <path
      d="M17.7014 30C8.22517 30 0.546875 27.3141 0.546875 24V36C0.546875 39.3141 8.22517 42 17.7014 42C27.1776 42 34.8559 39.3141 34.8559 36V24C34.8559 27.3141 27.1776 30 17.7014 30ZM17.7014 12C27.1776 12 34.8559 9.31406 34.8559 6C34.8559 2.68594 27.1776 0 17.7014 0C8.22517 0 0.546875 2.68594 0.546875 6C0.546875 9.31406 8.22517 12 17.7014 12Z"
      fill="#4372CE"
    />
    <g filter="url(#filter0_b_6439_11596)">
      <ellipse
        cx="34.4812"
        cy="41"
        rx="21.9578"
        ry="22"
        fill="url(#paint0_linear_6439_11596)"
        fill-opacity="0.2"
      />
      <path
        d="M34.4812 64C47.1623 64 57.439 53.7007 57.439 41C57.439 28.2993 47.1623 18 34.4812 18C21.8002 18 11.5234 28.2993 11.5234 41C11.5234 53.7007 21.8002 64 34.4812 64Z"
        stroke="white"
        stroke-width="2"
      />
    </g>
    <path
      d="M30.4274 32.0625H29.5013C29.1388 30.665 27.8794 29.625 26.3727 29.625C24.5837 29.625 23.1289 31.0826 23.1289 32.875C23.1289 34.6674 24.5837 36.125 26.3727 36.125C27.8802 36.125 29.138 35.085 29.5013 33.6875H30.4274C31.3218 33.6875 32.0493 34.4163 32.0493 35.3125V46.6875C32.0493 48.4799 33.5041 49.9375 35.293 49.9375H39.4629C39.8254 51.335 41.0847 52.375 42.5915 52.375C44.3804 52.375 45.8352 50.9174 45.8352 49.125C45.8352 47.3326 44.3804 45.875 42.5915 45.875C41.0839 45.875 39.8262 46.915 39.4629 48.3125H35.293C34.3985 48.3125 33.6711 47.5837 33.6711 46.6875V41.8125H39.4629C39.8254 43.21 41.0847 44.25 42.5915 44.25C44.3804 44.25 45.8352 42.7924 45.8352 41C45.8352 39.2076 44.3804 37.75 42.5915 37.75C41.0839 37.75 39.8262 38.79 39.4629 40.1875H33.6711V35.3125C33.6711 33.5201 32.2163 32.0625 30.4274 32.0625ZM26.3727 34.5C25.4782 34.5 24.7508 33.7712 24.7508 32.875C24.7508 31.9788 25.4782 31.25 26.3727 31.25C27.2671 31.25 27.9945 31.9788 27.9945 32.875C27.9945 33.7712 27.2671 34.5 26.3727 34.5ZM42.5915 47.5C43.4859 47.5 44.2134 48.2288 44.2134 49.125C44.2134 50.0212 43.4859 50.75 42.5915 50.75C41.697 50.75 40.9696 50.0212 40.9696 49.125C40.9696 48.2288 41.697 47.5 42.5915 47.5ZM42.5915 39.375C43.4859 39.375 44.2134 40.1038 44.2134 41C44.2134 41.8962 43.4859 42.625 42.5915 42.625C41.697 42.625 40.9696 41.8962 40.9696 41C40.9696 40.1038 41.697 39.375 42.5915 39.375Z"
      fill="white"
    />
    <defs>
      <filter
        id="filter0_b_6439_11596"
        x="-0.476562"
        y="6"
        width="69.9141"
        height="70"
        filterUnits="userSpaceOnUse"
        color-interpolation-filters="sRGB"
      >
        <feFlood flood-opacity="0" result="BackgroundImageFix" />
        <feGaussianBlur in="BackgroundImageFix" stdDeviation="5.5" />
        <feComposite in2="SourceAlpha" operator="in" result="effect1_backgroundBlur_6439_11596" />
        <feBlend
          mode="normal"
          in="SourceGraphic"
          in2="effect1_backgroundBlur_6439_11596"
          result="shape"
        />
      </filter>
      <linearGradient
        id="paint0_linear_6439_11596"
        x1="34.4812"
        y1="19"
        x2="34.4812"
        y2="63"
        gradientUnits="userSpaceOnUse"
      >
        <stop stop-color="#206AF2" />
        <stop offset="1" stop-color="#206AF2" />
      </linearGradient>
    </defs>
  </svg>
);
export const CommunityHouseContentSVG3 = () => (
  <svg viewBox="0 0 71 62" fill="none" xmlns="http://www.w3.org/2000/svg">
    <rect x="0.222656" y="34.7227" width="50.9021" height="3.28041" rx="1.6402" fill="#4372CE" />
    <path
      fill-rule="evenodd"
      clip-rule="evenodd"
      d="M7.02344 0C4.8143 0 3.02344 1.79086 3.02344 4V26.8905C3.02344 29.0996 4.8143 30.8905 7.02344 30.8905H44.3263C46.5355 30.8905 48.3263 29.0996 48.3263 26.8905V4C48.3263 1.79086 46.5355 0 44.3263 0H7.02344ZM23.3447 2.72852C22.6653 2.72852 22.1145 3.27927 22.1145 3.95867C22.1145 4.63806 22.6653 5.18882 23.3447 5.18882H28.0107C28.6901 5.18882 29.2408 4.63806 29.2408 3.95867C29.2408 3.27927 28.6901 2.72852 28.0107 2.72852H23.3447Z"
      fill="#4372CE"
    />
    <g filter="url(#filter0_b_6439_11604)">
      <path
        d="M46.1745 19.0933C46.511 18.8439 46.9705 18.8439 47.307 19.0933L57.541 26.6775L67.9026 34.0856C68.2433 34.3292 68.3853 34.7671 68.2526 35.1648L64.2159 47.2603L60.3858 59.423C60.2598 59.8229 59.8881 60.0935 59.4695 60.0899L46.7408 59.9811L34.012 60.0899C33.5935 60.0935 33.2217 59.8229 33.0957 59.423L29.2656 47.2603L25.2289 35.1648C25.0962 34.7671 25.2382 34.3292 25.5789 34.0856L35.9405 26.6775L46.1745 19.0933Z"
        fill="url(#paint0_linear_6439_11604)"
        fill-opacity="0.2"
      />
    </g>
    <path
      d="M42.841 35.0173C42.4956 34.6713 41.9775 34.6713 41.6321 35.0173L35.4153 41.0731C35.0699 41.4192 35.0699 41.9382 35.4153 42.2843L41.4594 48.3401C41.8048 48.6861 42.3229 48.6861 42.6683 48.3401C43.0137 47.994 43.0137 47.475 42.6683 47.1289L37.3149 41.7652L42.841 36.2285C43.0137 35.8825 43.0137 35.3634 42.841 35.0173ZM49.0578 35.0173C48.7124 35.0173 48.1944 35.1904 48.0217 35.7094L44.9133 47.475C44.7406 47.994 45.0859 48.3401 45.604 48.5131C46.1221 48.6861 46.4675 48.3401 46.6402 47.821L49.7486 36.0555C49.9213 35.7094 49.5759 35.1904 49.0578 35.0173ZM59.2465 41.0731L53.2024 35.0173C52.857 34.6713 52.3389 34.6713 51.9936 35.0173C51.6482 35.3634 51.6482 35.8825 51.9936 36.2285L57.347 41.7652L51.8209 47.3019C51.4755 47.648 51.4755 48.167 51.8209 48.5131C52.1662 48.8591 52.6843 48.8591 53.0297 48.5131L59.0739 42.4573C59.4192 42.1113 59.4192 41.4192 59.2465 41.0731Z"
      fill="white"
    />
    <g filter="url(#filter1_b_6439_11604)">
      <path
        fill-rule="evenodd"
        clip-rule="evenodd"
        d="M58.9206 25.1357L48.6996 17.5611C47.6902 16.813 46.3115 16.813 45.302 17.5611L35.0812 25.1356L24.7327 32.5343C23.7107 33.265 23.2846 34.5787 23.6828 35.7718L27.7144 47.8518L31.5396 59.999C31.9174 61.1987 33.0328 62.0106 34.2883 61.9999L47.0008 61.8912L59.7134 61.9999C60.9689 62.0106 62.0843 61.1987 62.4621 59.999L66.2872 47.8519L70.3189 35.7718C70.7171 34.5787 70.291 33.265 69.269 32.5343L58.9206 25.1357ZM64.476 47.2621L68.5127 35.1667C68.6454 34.769 68.5034 34.3311 68.1627 34.0875L57.8011 26.6794L47.5671 19.0952C47.2306 18.8458 46.7711 18.8458 46.4346 19.0952L36.2006 26.6794L25.839 34.0875C25.4983 34.3311 25.3563 34.769 25.489 35.1667L29.5257 47.2621L33.3558 59.4249C33.4817 59.8248 33.8535 60.0954 34.2721 60.0918L47.0008 59.983L59.7296 60.0918C60.1481 60.0954 60.5199 59.8248 60.6459 59.4249L64.476 47.2621Z"
        fill="white"
      />
    </g>
    <defs>
      <filter
        id="filter0_b_6439_11604"
        x="14.1797"
        y="7.90625"
        width="65.1211"
        height="63.1836"
        filterUnits="userSpaceOnUse"
        color-interpolation-filters="sRGB"
      >
        <feFlood flood-opacity="0" result="BackgroundImageFix" />
        <feGaussianBlur in="BackgroundImageFix" stdDeviation="5.5" />
        <feComposite in2="SourceAlpha" operator="in" result="effect1_backgroundBlur_6439_11604" />
        <feBlend
          mode="normal"
          in="SourceGraphic"
          in2="effect1_backgroundBlur_6439_11604"
          result="shape"
        />
      </filter>
      <filter
        id="filter1_b_6439_11604"
        x="12.5352"
        y="6"
        width="68.9297"
        height="67"
        filterUnits="userSpaceOnUse"
        color-interpolation-filters="sRGB"
      >
        <feFlood flood-opacity="0" result="BackgroundImageFix" />
        <feGaussianBlur in="BackgroundImageFix" stdDeviation="5.5" />
        <feComposite in2="SourceAlpha" operator="in" result="effect1_backgroundBlur_6439_11604" />
        <feBlend
          mode="normal"
          in="SourceGraphic"
          in2="effect1_backgroundBlur_6439_11604"
          result="shape"
        />
      </filter>
      <linearGradient
        id="paint0_linear_6439_11604"
        x1="46.7407"
        y1="18.6737"
        x2="46.7407"
        y2="64.4691"
        gradientUnits="userSpaceOnUse"
      >
        <stop stop-color="#206AF2" />
        <stop offset="1" stop-color="#206AF2" />
      </linearGradient>
    </defs>
  </svg>
);
export const CommunityHouseContentSVG4 = () => (
  <svg viewBox="0 0 65 65" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path
      d="M41.4545 17.6758C41.3376 16.1551 41.0553 16.0175 39.555 16.1372C37.8945 16.2697 36.4909 15.4418 35.9188 13.9924C35.3314 12.5099 35.756 10.9815 37.0503 9.91925C37.9225 9.20345 38.0293 8.62267 37.2385 7.7846C36.0484 6.52368 34.8075 5.30606 33.5132 4.15467C32.5088 3.26311 32.0409 3.37774 31.1916 4.45016C30.1541 5.75948 28.4937 6.14922 26.9858 5.44362C25.5719 4.78131 24.9083 3.57134 25.0176 1.85445C25.0913 0.677586 24.7455 0.264921 23.5733 0.175765C22.6578 0.10444 21.7424 0.056041 20.8829 0C19.9802 0.0993453 19.1386 0.173217 18.3045 0.285299C17.1373 0.440686 16.8856 0.782026 16.9873 1.97926C17.1424 3.7955 16.3872 5.16086 14.8818 5.78496C13.4222 6.39122 11.9118 5.95563 10.765 4.60045C10.086 3.79805 9.49356 3.68087 8.74342 4.39157C7.48217 5.57862 6.24381 6.80133 5.09444 8.10047C4.11291 9.20855 4.22225 9.58555 5.35635 10.5332C6.43452 11.4349 6.9024 12.5888 6.60235 13.9848C6.29466 15.4036 5.39704 16.3156 3.99339 16.6442C3.4772 16.7639 2.91014 16.6875 2.36852 16.6824C1.63109 16.6747 1.16575 17.011 1.06912 17.7344C0.802126 19.7417 0.791955 21.7515 1.15558 23.7512C1.29798 24.5408 1.72263 24.8465 2.51854 24.7981C2.93811 24.7726 3.36277 24.6733 3.77471 24.7141C5.24447 24.8593 6.39892 25.8374 6.7956 27.2155C7.19229 28.586 6.72186 29.9845 5.54198 30.9346C4.57062 31.7166 4.46382 32.2592 5.30804 33.1584C6.47775 34.4041 7.69068 35.6166 8.97227 36.745C10.0632 37.7054 10.4776 37.5933 11.388 36.4292C12.6365 34.8295 14.8742 34.6155 16.405 35.9273C17.4323 36.8087 17.7069 37.9219 17.5722 39.2159C17.473 40.1712 17.8239 40.7214 18.6605 40.7392C20.5397 40.7774 22.4239 40.7851 24.298 40.673C25.5185 40.5991 25.7601 40.1635 25.6228 38.9306C25.4219 37.1424 26.1721 35.7388 27.6698 35.102C29.1828 34.4601 30.7161 34.8957 31.8375 36.2865C32.5241 37.1373 33.1267 37.2621 33.9048 36.5183C35.194 35.288 36.4477 34.0118 37.6301 32.6795C38.4896 31.7115 38.3675 31.1893 37.3326 30.4073C36.468 29.7552 35.9798 28.8891 35.9188 27.8116C35.7916 25.6082 37.5843 23.9371 39.8119 24.1587C40.9485 24.2708 41.5054 23.9473 41.5308 22.9539C41.574 21.1962 41.5893 19.4284 41.4545 17.6758ZM21.2618 29.2687C16.3745 29.2152 12.4534 25.2312 12.517 20.3836C12.5806 15.5998 16.522 11.6667 21.2313 11.6871C26.0983 11.7075 30.1135 15.7169 30.0626 20.5135C30.0143 25.3738 26.0424 29.3222 21.2618 29.2687Z"
      fill="#4372CE"
    />
    <g filter="url(#filter0_b_6439_11617)">
      <rect
        x="25.8398"
        y="25.9414"
        width="36.9877"
        height="37.0588"
        fill="url(#paint0_linear_6439_11617)"
        fill-opacity="0.2"
      />
      <rect
        x="24.8398"
        y="24.9414"
        width="38.9877"
        height="39.0588"
        stroke="white"
        stroke-width="2"
      />
    </g>
    <path
      d="M40.6549 44.9317C40.6876 44.9329 40.7205 44.9336 40.7536 44.9336C41.3411 44.9336 41.8798 44.7305 42.2997 44.3924L46.4656 46.8251C46.4334 46.9802 46.4172 47.1379 46.4173 47.2961C46.4173 48.6009 47.5041 49.6586 48.8447 49.6586C50.1852 49.6586 51.272 48.6009 51.272 47.2961C51.272 46.5884 50.9523 45.9534 50.4458 45.5205L51.9824 41.7817C52.0151 41.783 52.048 41.7836 52.0811 41.7836C53.4216 41.7836 54.5084 40.7259 54.5084 39.4211C54.5084 38.1163 53.4216 37.0586 52.0811 37.0586C50.7405 37.0586 49.6538 38.1163 49.6538 39.4211C49.6538 40.1287 49.9734 40.7637 50.4799 41.1967L48.9434 44.9355C48.9106 44.9342 48.8777 44.9336 48.8447 44.9336C48.2572 44.9336 47.7184 45.1367 47.2985 45.4748L43.1327 43.042C43.1648 42.887 43.181 42.7292 43.1809 42.5711C43.1809 41.2663 42.0941 40.2086 40.7536 40.2086C39.413 40.2086 38.3263 41.2663 38.3263 42.5711C38.3263 43.2788 38.6459 43.9137 39.1524 44.3467L37.6159 48.0855C37.5831 48.0842 37.5502 48.0836 37.5172 48.0836C36.1766 48.0836 35.0898 49.1413 35.0898 50.4461C35.0898 51.7508 36.1766 52.8086 37.5171 52.8086C38.8577 52.8086 39.9445 51.7509 39.9445 50.4461C39.9445 49.7385 39.6248 49.1034 39.1183 48.6704L40.6549 44.9317Z"
      fill="white"
    />
    <defs>
      <filter
        id="filter0_b_6439_11617"
        x="12.8398"
        y="12.9414"
        width="62.9883"
        height="63.0586"
        filterUnits="userSpaceOnUse"
        color-interpolation-filters="sRGB"
      >
        <feFlood flood-opacity="0" result="BackgroundImageFix" />
        <feGaussianBlur in="BackgroundImageFix" stdDeviation="5.5" />
        <feComposite in2="SourceAlpha" operator="in" result="effect1_backgroundBlur_6439_11617" />
        <feBlend
          mode="normal"
          in="SourceGraphic"
          in2="effect1_backgroundBlur_6439_11617"
          result="shape"
        />
      </filter>
      <linearGradient
        id="paint0_linear_6439_11617"
        x1="44.3337"
        y1="25.9414"
        x2="44.3337"
        y2="63.0002"
        gradientUnits="userSpaceOnUse"
      >
        <stop stop-color="#206AF2" />
        <stop offset="1" stop-color="#206AF2" />
      </linearGradient>
    </defs>
  </svg>
);
export const CommunityHouseContentSVG5 = () => (
  <svg viewBox="0 0 65 65" fill="none" xmlns="http://www.w3.org/2000/svg">
    <rect x="14.582" width="10.7422" height="38.9118" rx="1" fill="#4372CE" />
    <rect x="0.535156" y="18.957" width="10.7422" height="19.9548" rx="1" fill="#4372CE" />
    <rect x="28.6289" y="12.9688" width="10.7422" height="25.9412" rx="1" fill="#4372CE" />
    <g filter="url(#filter0_b_6439_11621)">
      <ellipse
        cx="43.0709"
        cy="43.5457"
        rx="19.4185"
        ry="19.4559"
        fill="url(#paint0_linear_6439_11621)"
        fill-opacity="0.2"
      />
      <path
        d="M43.0709 64.0016C54.3495 64.0016 63.4894 54.8414 63.4894 43.5457C63.4894 32.2501 54.3495 23.0898 43.0709 23.0898C31.7922 23.0898 22.6523 32.2501 22.6523 43.5457C22.6523 54.8414 31.7922 64.0016 43.0709 64.0016Z"
        stroke="white"
        stroke-width="2"
      />
    </g>
    <path
      fill-rule="evenodd"
      clip-rule="evenodd"
      d="M34.7266 37.4717C34.7266 36.2114 35.7467 35.1875 37.0077 35.1875C38.2686 35.1875 39.2888 36.2114 39.2888 37.4717C39.2888 37.8669 39.1885 38.2389 39.0119 38.5633L40.0041 39.5574C40.7076 38.8774 41.6649 38.459 42.7204 38.459C43.5667 38.459 44.35 38.7281 44.9899 39.1853L45.5244 38.6498L45.6093 38.5648C45.4322 38.24 45.3316 37.8675 45.3316 37.4717C45.3316 36.2114 46.3517 35.1875 47.6127 35.1875C48.8737 35.1875 49.8938 36.2114 49.8938 37.4717C49.8938 38.7321 48.8737 39.756 47.6127 39.756C47.2206 39.756 46.8519 39.657 46.5298 39.4827L46.4445 39.5682L45.9082 40.1055C46.3643 40.7465 46.6326 41.5307 46.6326 42.3774C46.6326 43.2386 46.3551 44.0351 45.8847 44.682L47.7473 47.0148C48.1901 46.7701 48.6992 46.6309 49.2409 46.6309C50.9523 46.6309 52.3376 48.0206 52.3376 49.7322C52.3376 51.4439 50.9523 52.8336 49.2409 52.8336C47.5295 52.8336 46.1443 51.4439 46.1443 49.7322C46.1443 49.033 46.3754 48.3876 46.7655 47.8686L44.9515 45.5967C44.3188 46.0375 43.5499 46.2959 42.7204 46.2959C42.1953 46.2959 41.6945 46.1923 41.2371 46.0045L40.2493 46.9942C40.6692 47.5236 40.9198 48.1935 40.9198 48.9217C40.9198 50.6333 39.5346 52.023 37.8232 52.023C36.1118 52.023 34.7266 50.6333 34.7266 48.9217C34.7266 47.21 36.1118 45.8203 37.8232 45.8203C38.3344 45.8203 38.8166 45.9443 39.2414 46.1639L40.1086 45.2949C39.3102 44.5773 38.8082 43.5358 38.8082 42.3774C38.8082 41.7443 38.9582 41.1461 39.2245 40.6166L38.092 39.4819C37.7696 39.6567 37.4003 39.756 37.0077 39.756C35.7467 39.756 34.7266 38.7321 34.7266 37.4717ZM41.4309 44.6551L41.0884 44.3133L41.0289 44.3729C40.4657 43.8928 40.1082 43.1773 40.1082 42.3774C40.1082 40.9301 41.2789 39.759 42.7204 39.759C44.1619 39.759 45.3326 40.9301 45.3326 42.3774C45.3326 43.8248 44.1619 44.9959 42.7204 44.9959C42.2516 44.9959 41.8115 44.8721 41.4309 44.6551ZM37.0077 36.4875C36.467 36.4875 36.0266 36.927 36.0266 37.4717C36.0266 38.0165 36.467 38.456 37.0077 38.456C37.5483 38.456 37.9888 38.0165 37.9888 37.4717C37.9888 36.927 37.5483 36.4875 37.0077 36.4875ZM37.8232 47.1203C36.8321 47.1203 36.0266 47.9256 36.0266 48.9217C36.0266 49.9177 36.8321 50.723 37.8232 50.723C38.8143 50.723 39.6198 49.9177 39.6198 48.9217C39.6198 47.9256 38.8143 47.1203 37.8232 47.1203ZM47.4443 49.7322C47.4443 48.7362 48.2499 47.9309 49.2409 47.9309C50.232 47.9309 51.0376 48.7362 51.0376 49.7322C51.0376 50.7282 50.232 51.5336 49.2409 51.5336C48.2499 51.5336 47.4443 50.7282 47.4443 49.7322ZM46.6316 37.4717C46.6316 36.927 47.072 36.4875 47.6127 36.4875C48.1533 36.4875 48.5938 36.927 48.5938 37.4717C48.5938 38.0165 48.1533 38.456 47.6127 38.456C47.072 38.456 46.6316 38.0165 46.6316 37.4717Z"
      fill="white"
    />
    <defs>
      <filter
        id="filter0_b_6439_11621"
        x="10.6523"
        y="11.0898"
        width="64.8359"
        height="64.9102"
        filterUnits="userSpaceOnUse"
        color-interpolation-filters="sRGB"
      >
        <feFlood flood-opacity="0" result="BackgroundImageFix" />
        <feGaussianBlur in="BackgroundImageFix" stdDeviation="5.5" />
        <feComposite in2="SourceAlpha" operator="in" result="effect1_backgroundBlur_6439_11621" />
        <feBlend
          mode="normal"
          in="SourceGraphic"
          in2="effect1_backgroundBlur_6439_11621"
          result="shape"
        />
      </filter>
      <linearGradient
        id="paint0_linear_6439_11621"
        x1="43.0709"
        y1="24.0898"
        x2="43.0709"
        y2="63.0016"
        gradientUnits="userSpaceOnUse"
      >
        <stop stop-color="#206AF2" />
        <stop offset="1" stop-color="#206AF2" />
      </linearGradient>
    </defs>
  </svg>
);
export const CommunityHouseContentSVG6 = () => (
  <svg viewBox="0 0 67 65" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path
      fill-rule="evenodd"
      clip-rule="evenodd"
      d="M1.05469 0C0.502403 0 0.0546875 0.447715 0.0546875 1V36.5577C0.0546875 37.11 0.502403 37.5577 1.05469 37.5577H7.68573C8.1674 37.5577 8.58063 37.9011 8.66883 38.3746L9.90255 44.9985C10.0411 45.7423 10.9236 46.0688 11.5129 45.5942L21.2171 37.7789C21.3948 37.6357 21.6161 37.5577 21.8443 37.5577H50.9549C51.5072 37.5577 51.9549 37.11 51.9549 36.5577V1C51.9549 0.447715 51.5072 0 50.9549 0H1.05469ZM12.5729 22.75C14.5022 22.75 16.0662 21.183 16.0662 19.25C16.0662 17.317 14.5022 15.75 12.5729 15.75C10.6436 15.75 9.07963 17.317 9.07963 19.25C9.07963 21.183 10.6436 22.75 12.5729 22.75ZM29.6065 19.25C29.6065 21.183 28.0425 22.75 26.1133 22.75C24.184 22.75 22.62 21.183 22.62 19.25C22.62 17.317 24.184 15.75 26.1133 15.75C28.0425 15.75 29.6065 17.317 29.6065 19.25ZM39.6536 22.75C41.5829 22.75 43.1469 21.183 43.1469 19.25C43.1469 17.317 41.5829 15.75 39.6536 15.75C37.7243 15.75 36.1603 17.317 36.1603 19.25C36.1603 21.183 37.7243 22.75 39.6536 22.75Z"
      fill="#8BB3C4"
    />
    <g filter="url(#filter0_b_6439_11637)">
      <path
        d="M64.9688 23H19.0187V53.2413H45.9894L55.9785 60.5577L57.4769 53.2413H64.9688V23Z"
        fill="url(#paint0_linear_6439_11637)"
        fill-opacity="0.2"
      />
      <path
        d="M64.9688 22H65.9688V23V53.2413V54.2413H64.9688H58.2928L56.9582 60.7583L56.6454 62.2857L55.3876 61.3644L45.6623 54.2413H19.0187H18.0187V53.2413V23V22H19.0187H64.9688Z"
        stroke="white"
        stroke-width="2"
      />
    </g>
    <path
      d="M41.43 28C37.3072 28 33.9377 31.0207 33.9377 34.7867C33.9377 35.2807 33.9963 35.768 34.1107 36.242L33.0501 38.6213C33.0081 38.7156 32.9884 38.8183 32.9928 38.9214C32.9971 39.0245 33.0253 39.1252 33.0751 39.2156C33.1249 39.306 33.195 39.3835 33.2798 39.4421C33.3646 39.5007 33.4618 39.5388 33.5638 39.5533C34.6923 39.7147 35.158 40.2027 35.158 41.164V43.488C35.158 43.8416 35.2982 44.1808 35.5478 44.4308C35.7974 44.6809 36.1359 44.8213 36.4888 44.8213H36.9193C37.2723 44.8213 37.6107 44.9618 37.8603 45.2119C38.1099 45.4619 38.2501 45.801 38.2501 46.1547V47.3333C38.2501 47.5101 38.3202 47.6797 38.445 47.8047C38.5698 47.9298 38.739 48 38.9155 48H46.1017C46.2781 48 46.4474 47.9298 46.5722 47.8047C46.6969 47.6797 46.767 47.5101 46.767 47.3333C46.767 47.1565 46.6969 46.987 46.5722 46.8619C46.4474 46.7369 46.2781 46.6667 46.1017 46.6667H39.5809V46.154C39.5809 45.4468 39.3004 44.7685 38.8013 44.2684C38.3022 43.7683 37.6252 43.4873 36.9193 43.4873H36.4881V41.1633C36.4881 39.7953 35.8188 38.8573 34.5918 38.4313L35.4209 36.5713C35.4846 36.4285 35.4961 36.2678 35.4535 36.1173C35.3305 35.6843 35.2682 35.2362 35.2685 34.786C35.2685 31.792 38.0119 29.3327 41.43 29.3327C44.8481 29.3327 47.5915 31.7913 47.5915 34.786C47.5915 34.9628 47.6616 35.1324 47.7863 35.2574C47.9111 35.3824 48.0804 35.4527 48.2568 35.4527C48.4333 35.4527 48.6026 35.3824 48.7273 35.2574C48.8521 35.1324 48.9222 34.9628 48.9222 34.786C48.9222 31.0207 45.552 28 41.43 28ZM49.7926 36.6667C49.6161 36.6667 49.4468 36.7369 49.3221 36.8619C49.1973 36.987 49.1272 37.1565 49.1272 37.3333V44.8333C49.1272 45.0101 49.1973 45.1797 49.3221 45.3047C49.4468 45.4298 49.6161 45.5 49.7926 45.5C49.969 45.5 50.1383 45.4298 50.2631 45.3047C50.3878 45.1797 50.4579 45.0101 50.4579 44.8333V37.3333C50.4579 37.1565 50.3878 36.987 50.2631 36.8619C50.1383 36.7369 49.969 36.6667 49.7926 36.6667Z"
      fill="white"
    />
    <path
      d="M45.0081 37.0525C44.7639 36.5199 44.0014 36.5392 43.7851 37.0845L41.0238 44.0379C40.9585 44.2022 40.961 44.3858 41.0308 44.5483C41.1006 44.7108 41.232 44.8388 41.396 44.9042C41.5601 44.9696 41.7433 44.9671 41.9055 44.8971C42.0676 44.8272 42.1954 44.6956 42.2607 44.5312L42.9387 42.8245C42.9507 42.8252 42.9614 42.8312 42.9733 42.8312H46.1932L46.987 44.5625C47.0606 44.7232 47.195 44.8479 47.3604 44.9093C47.5259 44.9707 47.7089 44.9637 47.8693 44.8899C48.0296 44.8161 48.1541 44.6814 48.2153 44.5157C48.2766 44.3499 48.2696 44.1665 48.196 44.0059L45.0081 37.0525ZM43.4651 41.4972L44.4478 39.0239L45.5817 41.4972H43.4651Z"
      fill="white"
    />
    <defs>
      <filter
        id="filter0_b_6439_11637"
        x="6.01953"
        y="10"
        width="71.9492"
        height="65.0117"
        filterUnits="userSpaceOnUse"
        color-interpolation-filters="sRGB"
      >
        <feFlood flood-opacity="0" result="BackgroundImageFix" />
        <feGaussianBlur in="BackgroundImageFix" stdDeviation="5.5" />
        <feComposite in2="SourceAlpha" operator="in" result="effect1_backgroundBlur_6439_11637" />
        <feBlend
          mode="normal"
          in="SourceGraphic"
          in2="effect1_backgroundBlur_6439_11637"
          result="shape"
        />
      </filter>
      <linearGradient
        id="paint0_linear_6439_11637"
        x1="41.9937"
        y1="23"
        x2="41.9937"
        y2="60.5577"
        gradientUnits="userSpaceOnUse"
      >
        <stop stop-color="#20D9F2" />
        <stop offset="1" stop-color="#23A68E" />
      </linearGradient>
    </defs>
  </svg>
);
export const CommunityHouseContentSVG7 = () => (
  <svg viewBox="0 0 72 64" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path
      d="M50.9539 50.0687C50.2697 45.972 48.43 36.3402 45.9453 34.9128C44.1898 33.7833 39.8038 34.0137 35.1261 31.0129L35.0756 30.9792C34.6045 30.6195 33.8361 30.5408 33.8866 31.2096C34.1221 32.8954 32.2096 38.7004 29.6969 44.1176C29.0631 41.9204 27.874 38.8409 27.6385 38.2958C27.5936 38.1946 27.616 38.0373 27.6889 37.953C28.0311 37.5428 28.9285 36.4301 29.0687 35.8569C29.2538 35.1095 28.8668 34.5981 28.2722 34.1205C28.0255 33.9238 27.6272 33.8451 27.3412 33.9856L26.326 34.4408C26.0456 34.5813 25.5857 34.5813 25.3052 34.4408L24.29 33.9856C24.0096 33.8451 23.6058 33.9238 23.3646 34.1205C22.7701 34.5981 22.3775 35.1039 22.5626 35.8569C22.7084 36.4357 23.6058 37.5428 23.9479 37.953C24.0208 38.0429 24.0433 38.1946 23.9984 38.3014C23.7628 38.8353 22.5962 41.926 21.9624 44.1176C19.4497 38.6948 17.5315 32.8898 17.7671 31.2096C17.8176 30.5352 17.0548 30.6139 16.5836 30.9792C16.5836 30.9792 16.55 31.0016 16.5388 31.0129C11.8611 34.0137 7.47507 33.7777 5.71953 34.9128C3.30217 36.3008 1.44007 45.7754 0.710938 50.0687H50.9539ZM26.7971 19.3973C26.6794 19.0489 26.6177 18.6837 26.6177 18.2959C26.6177 18.1273 26.6289 17.9644 26.6513 17.8183C26.3877 17.7621 26.1073 17.734 25.8212 17.734H25.8156C25.5296 17.734 25.2547 17.7621 25.0136 17.8126C25.036 17.97 25.0472 18.1273 25.0472 18.2847C25.0472 18.5095 25.0248 18.723 24.9855 18.9365C25.552 19.0883 26.1577 19.2456 26.7971 19.3973ZM32.3666 18.2903C32.3666 17.0428 31.357 16.0312 30.1119 16.0312C28.8668 16.0312 27.8572 17.0484 27.8572 18.2903C27.8572 18.8691 28.0815 19.3861 28.4349 19.7907C29.2425 19.9762 30.1007 20.1728 31.0037 20.3639C31.8057 20.0155 32.3666 19.2175 32.3666 18.2903ZM21.5474 16.0312C20.6444 16.0312 19.8704 16.5651 19.5114 17.335C20.5546 17.689 21.9624 18.1273 23.774 18.6218C23.7909 18.5151 23.8077 18.4083 23.8077 18.2959C23.8077 17.0428 22.7925 16.0312 21.5474 16.0312Z"
      fill="#8BB3C4"
    />
    <path
      d="M30.1066 16.0312C28.8615 16.0312 27.8519 17.0484 27.8519 18.2903C27.8519 19.5378 28.8671 20.5493 30.1066 20.5493C31.3517 20.5493 32.3613 19.5378 32.3613 18.2903C32.3669 17.0428 31.3517 16.0312 30.1066 16.0312ZM21.5477 16.0312C20.3025 16.0312 19.293 17.0484 19.293 18.2903C19.293 19.5378 20.3081 20.5493 21.5477 20.5493C22.7928 20.5493 23.8024 19.5378 23.8024 18.2903C23.808 17.0428 22.7928 16.0312 21.5477 16.0312Z"
      fill="#8BB3C4"
    />
    <path
      d="M36.9487 11.7898C37.0441 8.55857 37.1226 5.76567 33.7686 3.97867L33.4545 3.81008L33.3255 3.48415C32.6749 1.86573 30.4538 0.0112875 25.019 4.85145e-05C20.6386 -0.0111905 17.8679 1.93316 16.9761 2.87724C14.4858 5.52403 14.3568 9.53637 14.7045 12.4248C14.8335 13.0654 15.0859 14.105 15.6075 14.9761C15.5627 15.0547 15.529 15.139 15.5122 15.1952C15.4168 15.5436 15.3383 16.2348 15.4729 17.679C15.5907 18.9322 15.8375 20.3315 16.0226 20.8035C16.1404 21.0957 16.3535 21.2868 16.6564 21.3767C17.5313 21.6296 17.722 22.1971 17.5594 21.5621C17.6603 21.933 17.7389 22.3095 17.7669 22.568C17.7893 22.7198 17.8062 22.8715 17.8118 23.0344C17.9295 25.9735 21.2724 31.357 25.821 31.357C30.3697 31.357 33.7181 25.9735 33.8303 23.1749C33.8303 23.0176 33.8415 22.8659 33.8583 22.731C33.8696 22.6523 33.8808 22.5568 33.8864 22.5006C33.9256 22.1915 34.122 21.6239 34.9913 21.3711C35.2998 21.2868 35.5129 21.0901 35.6251 20.7979C35.8102 20.3315 36.057 18.9266 36.1747 17.6734C36.315 16.2292 36.2364 15.5324 36.1355 15.1896C36.1243 15.1559 36.1074 15.1109 36.0906 15.066C36.6122 13.6611 36.9936 12.3855 36.9487 11.7898Z"
      fill="#8BB3C4"
    />
    <g filter="url(#filter0_b_6439_11657)">
      <path
        d="M50.7386 61.4342C51.12 62.118 52.1039 62.118 52.4853 61.4342L69.7461 30.4871C70.1178 29.8205 69.6359 29 68.8727 29H34.3512C33.588 29 33.1061 29.8205 33.4779 30.4871L50.7386 61.4342Z"
        fill="url(#paint0_linear_6439_11657)"
        fill-opacity="0.2"
      />
      <path
        d="M53.3587 61.9213C52.5958 63.289 50.6281 63.289 49.8653 61.9213L32.6045 30.9742C31.861 29.6411 32.8248 28 34.3512 28H68.8727C70.3992 28 71.3629 29.6411 70.6194 30.9742L53.3587 61.9213Z"
        stroke="white"
        stroke-width="2"
      />
    </g>
    <path
      d="M47.1221 40.75C47.9489 40.75 48.6192 40.0784 48.6192 39.25C48.6192 38.4216 47.9489 37.75 47.1221 37.75C46.2953 37.75 45.625 38.4216 45.625 39.25C45.625 40.0784 46.2953 40.75 47.1221 40.75Z"
      stroke="white"
      stroke-width="1.125"
    />
    <path
      d="M56.1026 43C56.9294 43 57.5997 42.3284 57.5997 41.5C57.5997 40.6716 56.9294 40 56.1026 40C55.2758 40 54.6055 40.6716 54.6055 41.5C54.6055 42.3284 55.2758 43 56.1026 43Z"
      stroke="white"
      stroke-width="1.125"
    />
    <path
      d="M49.7422 35.875L51.6136 34L53.485 35.875"
      stroke="white"
      stroke-width="1.125"
      stroke-linecap="square"
    />
    <path
      d="M51.1134 48.5L47.1211 43.0987V40.75"
      stroke="white"
      stroke-width="1.125"
      stroke-linecap="square"
    />
    <path
      d="M56.1046 43V44.7961L51.6133 48.5"
      stroke="white"
      stroke-width="1.125"
      stroke-linecap="square"
    />
    <path d="M51.6133 34.625V48.6264" stroke="white" stroke-width="1.125" stroke-linecap="square" />
    <path d="M50.4883 49H52.734" stroke="white" stroke-width="1.125" stroke-linecap="square" />
    <defs>
      <filter
        id="filter0_b_6439_11657"
        x="20.3477"
        y="16"
        width="62.5312"
        height="58.9453"
        filterUnits="userSpaceOnUse"
        color-interpolation-filters="sRGB"
      >
        <feFlood flood-opacity="0" result="BackgroundImageFix" />
        <feGaussianBlur in="BackgroundImageFix" stdDeviation="5.5" />
        <feComposite in2="SourceAlpha" operator="in" result="effect1_backgroundBlur_6439_11657" />
        <feBlend
          mode="normal"
          in="SourceGraphic"
          in2="effect1_backgroundBlur_6439_11657"
          result="shape"
        />
      </filter>
      <linearGradient
        id="paint0_linear_6439_11657"
        x1="51.612"
        y1="63"
        x2="51.612"
        y2="29"
        gradientUnits="userSpaceOnUse"
      >
        <stop stop-color="#20D9F2" />
        <stop offset="1" stop-color="#23A68E" />
      </linearGradient>
    </defs>
  </svg>
);

export const CommunityHouseContentSVG8 = () => (
  <svg viewBox="0 0 76 66" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path
      d="M1.37109 1H46.6599C46.6599 1 51.988 3.66917 51.988 10.3421C51.988 17.015 46.6599 19.6842 46.6599 19.6842H1.37109C1.37109 19.6842 6.69919 17.015 6.69919 10.3421C6.69919 3.66917 1.37109 1 1.37109 1Z"
      fill="#8BB3C4"
      stroke="#8BB3C4"
      stroke-width="1.125"
      stroke-linecap="square"
    />
    <path
      d="M51.988 25.5586H6.69919C6.69919 25.5586 1.37109 28.2278 1.37109 34.9007C1.37109 41.5736 6.69919 44.2428 6.69919 44.2428H51.988C51.988 44.2428 46.6599 41.5736 46.6599 34.9007C46.6599 28.2278 51.988 25.5586 51.988 25.5586Z"
      fill="#8BB3C4"
      stroke="#8BB3C4"
      stroke-width="1.125"
      stroke-linecap="square"
    />
    <g filter="url(#filter0_b_6439_11648)">
      <rect
        x="29.3164"
        y="26"
        width="43.8464"
        height="29.6532"
        rx="1"
        fill="url(#paint0_linear_6439_11648)"
        fill-opacity="0.2"
      />
      <rect
        x="28.3164"
        y="25"
        width="45.8464"
        height="31.6532"
        rx="2"
        stroke="white"
        stroke-width="2"
      />
    </g>
    <path
      d="M48.6307 45.2457C47.7944 45.1519 46.9658 44.9995 46.1508 44.7898C45.8434 46.5749 46.0673 47.9242 46.8329 48.3672C47.5978 48.8095 48.8762 48.3286 50.2663 47.1707C49.6769 46.5681 49.1304 45.9249 48.6307 45.2457ZM50.2775 45.3712C50.5704 45.721 50.8666 46.0466 51.1603 46.3441C51.4556 46.0466 51.7518 45.721 52.0447 45.3712C51.4559 45.3938 50.8664 45.3938 50.2775 45.3712ZM44.9815 37.2812C44.5561 34.93 44.9237 33.0468 46.227 32.2934C47.5304 31.5392 49.3433 32.1623 51.1627 33.7086C51.4203 33.4899 51.678 33.2889 51.9348 33.1071C51.9996 33.0578 52.0736 33.0221 52.1525 33.0021C52.2313 32.9821 52.3134 32.9782 52.3938 32.9906C52.4742 33.0031 52.5513 33.0316 52.6205 33.0746C52.6896 33.1175 52.7495 33.174 52.7964 33.2406C52.8433 33.3072 52.8763 33.3826 52.8935 33.4622C52.9107 33.5419 52.9117 33.6243 52.8965 33.7043C52.8812 33.7844 52.85 33.8606 52.8048 33.9283C52.7595 33.9961 52.7011 34.054 52.633 34.0986C52.442 34.2337 52.2502 34.3816 52.0568 34.5408C52.6455 35.1433 53.1915 35.7862 53.6908 36.465C54.5711 36.5663 55.4042 36.7207 56.1706 36.921C56.2027 36.7304 56.2292 36.543 56.2493 36.3613C56.2553 36.28 56.2777 36.2008 56.3149 36.1283C56.3522 36.0559 56.4037 35.9917 56.4662 35.9396C56.5288 35.8874 56.6012 35.8485 56.6791 35.825C56.7571 35.8016 56.8389 35.7941 56.9198 35.803C57.0006 35.8119 57.0789 35.837 57.1499 35.8769C57.2208 35.9168 57.2831 35.9706 57.3328 36.0351C57.3826 36.0995 57.4189 36.1734 57.4396 36.2523C57.4602 36.3311 57.4648 36.4133 57.4531 36.494C57.425 36.7497 57.3865 37.0118 57.3375 37.2796C59.5839 38.0861 61.0293 39.3477 61.0293 40.8554C61.0293 42.3631 59.5847 43.6239 57.34 44.4296C57.7653 46.7808 57.3978 48.6639 56.0952 49.4182C54.7919 50.1716 52.9797 49.5484 51.1611 48.0046C49.3418 49.5484 47.5296 50.1716 46.227 49.4182C44.9237 48.6639 44.5561 46.7808 44.9815 44.4296C42.7375 43.6247 41.293 42.3631 41.293 40.8554C41.293 39.3477 42.7375 38.0869 44.9815 37.2812ZM46.15 36.921C46.918 36.7199 47.7519 36.5663 48.6331 36.4642C49.1587 35.7566 49.7085 35.1109 50.2687 34.5424C48.8778 33.3821 47.5986 32.9013 46.8329 33.3444C46.0673 33.7866 45.8434 35.1359 46.1508 36.921L46.15 36.921ZM51.1595 35.365C50.8626 35.6658 50.5656 35.9914 50.2743 36.3396C50.8642 36.3169 51.4548 36.3169 52.0447 36.3396C51.751 35.989 51.4548 35.6642 51.1595 35.365ZM56.1714 44.789C55.4042 44.9901 54.5711 45.1444 53.6916 45.2457C53.1918 45.9249 52.6453 46.5681 52.0559 47.1707C53.446 48.3286 54.7236 48.8095 55.4893 48.3672C56.2549 47.9242 56.4788 46.5741 56.1714 44.789ZM47.6989 43.8804C47.3852 43.3808 47.0907 42.8692 46.8161 42.347C46.6659 42.7589 46.5326 43.1769 46.4164 43.5998C46.8217 43.7067 47.2503 43.8008 47.6989 43.8804ZM49.296 44.0919C50.5369 44.2036 51.7853 44.2036 53.0262 44.0919C53.7423 43.0707 54.3664 41.9879 54.8914 40.8562C54.3675 39.7234 53.7433 38.64 53.0263 37.6189C51.7848 37.5071 50.5358 37.5071 49.2944 37.6189C48.5789 38.6404 47.9552 39.7235 47.4309 40.8554C47.9548 41.9879 48.579 43.0711 49.296 44.0919L49.296 44.0919ZM55.5077 39.367C55.6626 38.9401 55.7966 38.5203 55.9074 38.1119C55.5021 38.0049 55.0727 37.9108 54.6233 37.8304C54.9376 38.3308 55.2327 38.8431 55.5077 39.3662V39.367ZM45.2551 38.4745C43.5585 39.1017 42.504 39.9701 42.504 40.8554C42.504 41.7407 43.5585 42.61 45.2551 43.2355C45.4654 42.47 45.7487 41.67 46.101 40.8554C45.764 40.0828 45.4814 39.2875 45.2551 38.4753V38.4745ZM46.4164 38.111C46.5272 38.5155 46.6596 38.9345 46.8153 39.3646C47.0904 38.8421 47.3854 38.3303 47.6997 37.8304C47.2503 37.9108 46.8217 38.0041 46.4164 38.111ZM57.0663 43.2363C58.7629 42.6091 59.8174 41.7407 59.8174 40.8554C59.8174 39.9693 58.7621 39.1001 57.0647 38.4737C56.8386 39.2857 56.5565 40.081 56.2204 40.8538C56.5735 41.6683 56.8568 42.47 57.0671 43.2363H57.0663ZM55.905 43.5997C55.7891 43.1766 55.6561 42.7584 55.5061 42.3462C55.2319 42.8689 54.9374 43.3807 54.6233 43.8804C55.0542 43.8044 55.4818 43.7108 55.905 43.5998L55.905 43.5997ZM55.7926 34.5698C55.5554 34.5749 55.3196 34.5326 55.099 34.4452C54.8784 34.3578 54.6775 34.2272 54.5079 34.0609C54.3384 33.8947 54.2037 33.6962 54.1117 33.4771C54.0198 33.2581 53.9724 33.0228 53.9724 32.7851C53.9724 32.5474 54.0198 32.3121 54.1117 32.0931C54.2037 31.874 54.3384 31.6755 54.5079 31.5093C54.6775 31.343 54.8784 31.2124 55.099 31.125C55.3196 31.0376 55.5554 30.9953 55.7926 31.0004C56.2584 31.0105 56.7016 31.203 57.0274 31.5366C57.3533 31.8702 57.5357 32.3183 57.5357 32.7851C57.5357 33.2518 57.3533 33.7 57.0274 34.0336C56.7016 34.3672 56.2584 34.5597 55.7926 34.5698Z"
      fill="white"
    />
    <g filter="url(#filter1_b_6439_11648)">
      <rect
        x="34.5586"
        y="61.8086"
        width="33.981"
        height="2.19654"
        rx="1"
        fill="url(#paint1_linear_6439_11648)"
        fill-opacity="0.1"
      />
      <rect
        x="33.5586"
        y="60.8086"
        width="35.981"
        height="4.19654"
        rx="2"
        stroke="white"
        stroke-width="2"
      />
    </g>
    <defs>
      <filter
        id="filter0_b_6439_11648"
        x="16.3164"
        y="13"
        width="69.8477"
        height="55.6523"
        filterUnits="userSpaceOnUse"
        color-interpolation-filters="sRGB"
      >
        <feFlood flood-opacity="0" result="BackgroundImageFix" />
        <feGaussianBlur in="BackgroundImageFix" stdDeviation="5.5" />
        <feComposite in2="SourceAlpha" operator="in" result="effect1_backgroundBlur_6439_11648" />
        <feBlend
          mode="normal"
          in="SourceGraphic"
          in2="effect1_backgroundBlur_6439_11648"
          result="shape"
        />
      </filter>
      <filter
        id="filter1_b_6439_11648"
        x="21.5586"
        y="48.8086"
        width="59.9805"
        height="28.1953"
        filterUnits="userSpaceOnUse"
        color-interpolation-filters="sRGB"
      >
        <feFlood flood-opacity="0" result="BackgroundImageFix" />
        <feGaussianBlur in="BackgroundImageFix" stdDeviation="5.5" />
        <feComposite in2="SourceAlpha" operator="in" result="effect1_backgroundBlur_6439_11648" />
        <feBlend
          mode="normal"
          in="SourceGraphic"
          in2="effect1_backgroundBlur_6439_11648"
          result="shape"
        />
      </filter>
      <linearGradient
        id="paint0_linear_6439_11648"
        x1="51.2396"
        y1="26"
        x2="51.2396"
        y2="55.6532"
        gradientUnits="userSpaceOnUse"
      >
        <stop stop-color="#229DAE" />
        <stop offset="1" stop-color="#23A68E" />
      </linearGradient>
      <linearGradient
        id="paint1_linear_6439_11648"
        x1="51.5491"
        y1="61.8086"
        x2="51.5491"
        y2="64.0051"
        gradientUnits="userSpaceOnUse"
      >
        <stop stop-color="#20D9F2" />
        <stop offset="1" stop-color="#23A68E" />
      </linearGradient>
    </defs>
  </svg>
);
